// Recovered compiled webpack factory 32164. Edit this function expression; run npm run build.
(t, e, i) => {
  let n, s;
  i.d(e, { P: () => iO });
  var r = i(34576),
    o = i(3729),
    a = i(12115);
  let l = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view",
  ];
  function h(t) {
    if ("string" != typeof t || t.includes("-"));
    else if (l.indexOf(t) > -1 || /[A-Z]/u.test(t)) return !0;
    return !1;
  }
  var u = i(95155),
    d = i(60296);
  let c = (0, a.createContext)({ strict: !1 });
  var p = i(53127);
  let m = (0, a.createContext)({});
  var f = i(28033),
    v = i(19461);
  function y(t) {
    return Array.isArray(t) ? t.join(" ") : t;
  }
  var g = i(33182),
    x = i(93709),
    w = i(38708);
  let T = () => ({ style: {}, transform: {}, transformOrigin: {}, vars: {} });
  function b(t, e, i) {
    for (let n in e) (0, g.S)(e[n]) || (0, x.zK)(n, i) || (t[n] = e[n]);
  }
  var S = i(31439),
    P = i(36795);
  let A = () => ({ ...T(), attrs: {} }),
    E = new Set([
      "animate",
      "exit",
      "variants",
      "initial",
      "style",
      "values",
      "variants",
      "transition",
      "transformTemplate",
      "custom",
      "inherit",
      "onBeforeLayoutMeasure",
      "onAnimationStart",
      "onAnimationComplete",
      "onUpdate",
      "onDragStart",
      "onDrag",
      "onDragEnd",
      "onMeasureDragConstraints",
      "onDirectionLock",
      "onDragTransitionEnd",
      "_dragX",
      "_dragY",
      "onHoverStart",
      "onHoverEnd",
      "onViewportEnter",
      "onViewportLeave",
      "globalTapTarget",
      "propagate",
      "ignoreStrict",
      "viewport",
    ]);
  function M(t) {
    return (
      t.startsWith("while") ||
      (t.startsWith("drag") && "draggable" !== t) ||
      t.startsWith("layout") ||
      t.startsWith("onTap") ||
      t.startsWith("onPan") ||
      t.startsWith("onLayout") ||
      E.has(t)
    );
  }
  let k = (t) => !M(t);
  try {
    !(function (t) {
      "function" == typeof t && (k = (e) => (e.startsWith("on") ? !M(e) : t(e)));
    })(require("@emotion/is-prop-valid").default);
  } catch {}
  var V = i(76066);
  function C(t) {
    return (0, g.S)(t) ? t.get() : t;
  }
  var D = i(36874),
    R = i(10883),
    L = i(59686),
    j = i(94416);
  let B = (t) => (e, i) => {
      let n = (0, a.useContext)(m),
        s = (0, a.useContext)(L.t),
        r = () =>
          (function (t, e, i, n) {
            let { scrapeMotionValuesFromProps: s, createRenderState: r } = t;
            return {
              latestValues: (function (t, e, i, n) {
                let s = {},
                  r = n(t, {});
                for (let t in r) s[t] = C(r[t]);
                let { initial: o, animate: a } = t,
                  l = (0, f.e)(t),
                  h = (0, f.O)(t);
                e &&
                  h &&
                  !l &&
                  !1 !== t.inherit &&
                  (void 0 === o && (o = e.initial), void 0 === a && (a = e.animate));
                let u = !!i && !1 === i.initial,
                  d = (u = u || !1 === o) ? a : o;
                if (d && "boolean" != typeof d && !(0, D.N)(d)) {
                  let e = Array.isArray(d) ? d : [d];
                  for (let i = 0; i < e.length; i++) {
                    let n = (0, R.a)(t, e[i]);
                    if (n) {
                      let { transitionEnd: t, transition: e, ...i } = n;
                      for (let t in i) {
                        let e = i[t];
                        if (Array.isArray(e)) {
                          let t = u ? e.length - 1 : 0;
                          e = e[t];
                        }
                        null !== e && (s[t] = e);
                      }
                      for (let e in t) s[e] = t[e];
                    }
                  }
                }
                return s;
              })(e, i, n, s),
              renderState: r(),
            };
          })(t, e, n, s);
      return i ? r() : (0, j.M)(r);
    },
    F = B({ scrapeMotionValuesFromProps: V.x, createRenderState: T }),
    I = B({ scrapeMotionValuesFromProps: i(35043).x, createRenderState: A });
  var O = i(12583);
  let U = {
      animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag",
      ],
      exit: ["exit"],
      drag: ["drag", "dragControls"],
      focus: ["whileFocus"],
      hover: ["whileHover", "onHoverStart", "onHoverEnd"],
      tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
      pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
      inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
      layout: ["layout", "layoutId"],
    },
    W = !1;
  function N() {
    return (
      !(function () {
        if (W) return;
        let t = {};
        for (let e in U) t[e] = { isEnabled: (t) => U[e].some((e) => !!t[e]) };
        ((0, O.lr)(t), (W = !0));
      })(),
      (0, O.vK)()
    );
  }
  let $ = Symbol.for("motionComponentSymbol");
  var G = i(99256);
  let X = (0, a.createContext)({});
  function q(t) {
    return t && "object" == typeof t && Object.prototype.hasOwnProperty.call(t, "current");
  }
  var K = i(46436);
  function H(t) {
    let { forwardMotionProps: e = !1, type: i } =
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      n = arguments.length > 2 ? arguments[2] : void 0,
      s = arguments.length > 3 ? arguments[3] : void 0;
    n &&
      (function (t) {
        let e = N();
        for (let i in t) e[i] = { ...e[i], ...t[i] };
        (0, O.lr)(e);
      })(n);
    let r = i ? "svg" === i : h(t),
      o = r ? I : F;
    function l(i, n) {
      let l,
        x = {
          ...(0, a.useContext)(p.Q),
          ...i,
          layoutId: (function (t) {
            let { layoutId: e } = t,
              i = (0, a.useContext)(d.L).id;
            return i && void 0 !== e ? i + "-" + e : e;
          })(i),
        },
        { isStatic: E } = x,
        V = (function (t) {
          let { initial: e, animate: i } = (function (t, e) {
            if ((0, f.e)(t)) {
              let { initial: e, animate: i } = t;
              return {
                initial: !1 === e || (0, v.w)(e) ? e : void 0,
                animate: (0, v.w)(i) ? i : void 0,
              };
            }
            return !1 !== t.inherit ? e : {};
          })(t, (0, a.useContext)(m));
          return (0, a.useMemo)(() => ({ initial: e, animate: i }), [y(e), y(i)]);
        })(i),
        C = o(i, E);
      if (!E && "undefined" != typeof window) {
        (0, a.useContext)(c).strict;
        let e = (function (t) {
          let { drag: e, layout: i } = N();
          if (!e && !i) return {};
          let n = { ...e, ...i };
          return {
            MeasureLayout:
              (null == e ? void 0 : e.isEnabled(t)) || (null == i ? void 0 : i.isEnabled(t))
                ? n.MeasureLayout
                : void 0,
            ProjectionNode: n.ProjectionNode,
          };
        })(x);
        ((l = e.MeasureLayout),
          (V.visualElement = (function (t, e, i, n, s, r) {
            var o, l, h, u;
            let { visualElement: d } = (0, a.useContext)(m),
              f = (0, a.useContext)(c),
              v = (0, a.useContext)(L.t),
              y = (0, a.useContext)(p.Q),
              g = y.reducedMotion,
              x = y.skipAnimations,
              w = (0, a.useRef)(null),
              T = (0, a.useRef)(!1);
            ((n = n || f.renderer),
              !w.current &&
                n &&
                ((w.current = n(t, {
                  visualState: e,
                  parent: d,
                  props: i,
                  presenceContext: v,
                  blockInitialAnimation: !!v && !1 === v.initial,
                  reducedMotionConfig: g,
                  skipAnimations: x,
                  isSVG: r,
                })),
                T.current && w.current && (w.current.manuallyAnimateOnMount = !0)));
            let b = w.current,
              S = (0, a.useContext)(X);
            b &&
              !b.projection &&
              s &&
              ("html" === b.type || "svg" === b.type) &&
              (function (t, e, i, n) {
                let {
                  layoutId: s,
                  layout: r,
                  drag: o,
                  dragConstraints: a,
                  layoutScroll: l,
                  layoutRoot: h,
                  layoutAnchor: u,
                  layoutCrossfade: d,
                } = e;
                ((t.projection = new i(
                  t.latestValues,
                  e["data-framer-portal-id"]
                    ? void 0
                    : (function t(e) {
                        if (e) return !1 !== e.options.allowProjection ? e.projection : t(e.parent);
                      })(t.parent),
                )),
                  t.projection.setOptions({
                    layoutId: s,
                    layout: r,
                    alwaysMeasureLayout: !!o || (a && q(a)),
                    visualElement: t,
                    animationType: "string" == typeof r ? r : "both",
                    initialPromotionConfig: n,
                    crossfade: d,
                    layoutScroll: l,
                    layoutRoot: h,
                    layoutAnchor: u,
                  }));
              })(w.current, i, s, S);
            let P = (0, a.useRef)(!1);
            (0, a.useInsertionEffect)(() => {
              b && P.current && b.update(i, v);
            });
            let A = i[G.n],
              E = (0, a.useRef)(
                !!A &&
                  "undefined" != typeof window &&
                  !(null == (o = (l = window).MotionHandoffIsComplete) ? void 0 : o.call(l, A)) &&
                  (null == (h = (u = window).MotionHasOptimisedAnimation) ? void 0 : h.call(u, A)),
              );
            return (
              (0, K.E)(() => {
                ((T.current = !0),
                  b &&
                    ((P.current = !0),
                    (window.MotionIsMounted = !0),
                    b.updateFeatures(),
                    b.scheduleRenderMicrotask(),
                    E.current && b.animationState && b.animationState.animateChanges()));
              }),
              (0, a.useEffect)(() => {
                b &&
                  (!E.current && b.animationState && b.animationState.animateChanges(),
                  E.current &&
                    (queueMicrotask(() => {
                      var t, e;
                      null == (t = (e = window).MotionHandoffMarkAsComplete) || t.call(e, A);
                    }),
                    (E.current = !1)),
                  (b.enteringChildren = void 0));
              }),
              b
            );
          })(t, C, x, s, e.ProjectionNode, r)));
      }
      return (0, u.jsxs)(m.Provider, {
        value: V,
        children: [
          l && V.visualElement ? (0, u.jsx)(l, { visualElement: V.visualElement, ...x }) : null,
          (function (t, e, i, n, s) {
            let { latestValues: r } = n,
              o = arguments.length > 5 && void 0 !== arguments[5] && arguments[5],
              l = arguments.length > 6 ? arguments[6] : void 0,
              u = (
                (l ?? h(t))
                  ? function (t, e, i, n) {
                      let s = (0, a.useMemo)(() => {
                        let i = A();
                        return (
                          (0, S.B)(i, e, (0, P.n)(n), t.transformTemplate, t.style),
                          { ...i.attrs, style: { ...i.style } }
                        );
                      }, [e]);
                      if (t.style) {
                        let e = {};
                        (b(e, t.style, t), (s.style = { ...e, ...s.style }));
                      }
                      return s;
                    }
                  : function (t, e) {
                      let i = {},
                        n = (function (t, e) {
                          let i = t.style || {},
                            n = {};
                          return (
                            b(n, i, t),
                            Object.assign(
                              n,
                              (function (t, e) {
                                let { transformTemplate: i } = t;
                                return (0, a.useMemo)(() => {
                                  let t = T();
                                  return ((0, w.O)(t, e, i), Object.assign({}, t.vars, t.style));
                                }, [e]);
                              })(t, e),
                            ),
                            n
                          );
                        })(t, e);
                      return (
                        t.drag &&
                          !1 !== t.dragListener &&
                          ((i.draggable = !1),
                          (n.userSelect = n.WebkitUserSelect = n.WebkitTouchCallout = "none"),
                          (n.touchAction =
                            !0 === t.drag ? "none" : `pan-${"x" === t.drag ? "y" : "x"}`)),
                        void 0 === t.tabIndex &&
                          (t.onTap || t.onTapStart || t.whileTap) &&
                          (i.tabIndex = 0),
                        (i.style = n),
                        i
                      );
                    }
              )(e, r, s, t),
              d = (function (t, e, i) {
                let n = {};
                for (let s in t)
                  ("values" !== s || "object" != typeof t.values) &&
                    !(0, g.S)(t[s]) &&
                    (k(s) ||
                      (!0 === i && M(s)) ||
                      (!e && !M(s)) ||
                      (t.draggable && s.startsWith("onDrag"))) &&
                    (n[s] = t[s]);
                return n;
              })(e, "string" == typeof t, o),
              c = t !== a.Fragment ? { ...d, ...u, ref: i } : {},
              { children: p } = e,
              m = (0, a.useMemo)(() => ((0, g.S)(p) ? p.get() : p), [p]);
            return (0, a.createElement)(t, { ...c, children: m });
          })(
            t,
            i,
            (function (t, e, i) {
              let n = (0, a.useRef)(i);
              (0, a.useInsertionEffect)(() => {
                n.current = i;
              });
              let s = (0, a.useRef)(null);
              return (0, a.useCallback)(
                (i) => {
                  if (i) {
                    var r;
                    null == (r = t.onMount) || r.call(t, i);
                  }
                  let o = n.current;
                  if ("function" == typeof o)
                    if (i) {
                      let t = o(i);
                      "function" == typeof t && (s.current = t);
                    } else s.current ? (s.current(), (s.current = null)) : o(i);
                  else o && (o.current = i);
                  e && (i ? e.mount(i) : e.unmount());
                },
                [e],
              );
            })(C, V.visualElement, n),
            C,
            E,
            e,
            r,
          ),
        ],
      });
    }
    l.displayName = `motion.${"string" == typeof t ? t : `create(${t.displayName ?? t.name ?? ""})`}`;
    let x = (0, a.forwardRef)(l);
    return ((x[$] = t), x);
  }
  class z {
    constructor(t) {
      ((this.isMounted = !1), (this.node = t));
    }
    update() {}
  }
  var Y = i(21767),
    Q = i(2877);
  function _(t, e, i, n = 0, s = 1) {
    let r = Array.from(t)
        .sort((t, e) => t.sortNodePosition(e))
        .indexOf(e),
      o = t.size,
      a = (o - 1) * n;
    return "function" == typeof i ? i(r, o) : 1 === s ? r * n : a - r * n;
  }
  function Z(t, e, i = {}) {
    let n = (0, Y.K)(t, e, "exit" === i.type ? t.presenceContext?.custom : void 0),
      { transition: s = t.getDefaultTransition() || {} } = n || {};
    i.transitionOverride && (s = i.transitionOverride);
    let r = n ? () => Promise.all((0, Q.$)(t, n, i)) : () => Promise.resolve(),
      o =
        t.variantChildren && t.variantChildren.size
          ? (n = 0) => {
              let { delayChildren: r = 0, staggerChildren: o, staggerDirection: a } = s;
              return (function (t, e, i = 0, n = 0, s = 0, r = 1, o) {
                let a = [];
                for (let l of t.variantChildren)
                  (l.notify("AnimationStart", e),
                    a.push(
                      Z(l, e, {
                        ...o,
                        delay:
                          i + ("function" == typeof n ? 0 : n) + _(t.variantChildren, l, n, s, r),
                      }).then(() => l.notify("AnimationComplete", e)),
                    ));
                return Promise.all(a);
              })(t, e, n, r, o, a, i);
            }
          : () => Promise.resolve(),
      { when: a } = s;
    if (!a) return Promise.all([r(), o(i.delay)]);
    {
      let [t, e] = "beforeChildren" === a ? [r, o] : [o, r];
      return t().then(() => e());
    }
  }
  var J = i(52036);
  let tt = J._.length;
  var te = i(7112);
  function ti(t, e) {
    if (!Array.isArray(e)) return !1;
    let i = e.length;
    if (i !== t.length) return !1;
    for (let n = 0; n < i; n++) if (e[n] !== t[n]) return !1;
    return !0;
  }
  let tn = [...J.U].reverse(),
    ts = J.U.length;
  function tr(t = !1) {
    return { isActive: t, protectedKeys: {}, needsAnimating: {}, prevResolvedValues: {} };
  }
  function to() {
    return {
      animate: tr(!0),
      whileInView: tr(),
      whileHover: tr(),
      whileTap: tr(),
      whileDrag: tr(),
      whileFocus: tr(),
      exit: tr(),
    };
  }
  class ta extends z {
    constructor(t) {
      (super(t),
        t.animationState ||
          (t.animationState = (function (t) {
            let e = (e) =>
                Promise.all(
                  e.map(({ animation: e, options: i }) =>
                    (function (t, e, i = {}) {
                      let n;
                      if ((t.notify("AnimationStart", e), Array.isArray(e)))
                        n = Promise.all(e.map((e) => Z(t, e, i)));
                      else if ("string" == typeof e) n = Z(t, e, i);
                      else {
                        let s = "function" == typeof e ? (0, Y.K)(t, e, i.custom) : e;
                        n = Promise.all((0, Q.$)(t, s, i));
                      }
                      return n.then(() => {
                        t.notify("AnimationComplete", e);
                      });
                    })(t, e, i),
                  ),
                ),
              i = to(),
              n = !0,
              s = !1,
              r = (e) => (i, n) => {
                let s = (0, Y.K)(t, n, "exit" === e ? t.presenceContext?.custom : void 0);
                if (s) {
                  let { transition: t, transitionEnd: e, ...n } = s;
                  i = { ...i, ...n, ...e };
                }
                return i;
              };
            function o(o) {
              let { props: a } = t,
                l =
                  (function t(e) {
                    if (!e) return;
                    if (!e.isControllingVariants) {
                      let i = (e.parent && t(e.parent)) || {};
                      return (void 0 !== e.props.initial && (i.initial = e.props.initial), i);
                    }
                    let i = {};
                    for (let t = 0; t < tt; t++) {
                      let n = J._[t],
                        s = e.props[n];
                      ((0, v.w)(s) || !1 === s) && (i[n] = s);
                    }
                    return i;
                  })(t.parent) || {},
                h = [],
                u = new Set(),
                d = {},
                c = 1 / 0;
              for (let e = 0; e < ts; e++) {
                var p, m;
                let f = tn[e],
                  y = i[f],
                  g = void 0 !== a[f] ? a[f] : l[f],
                  x = (0, v.w)(g),
                  w = f === o ? y.isActive : null;
                !1 === w && (c = e);
                let T = g === l[f] && g !== a[f] && x;
                if (
                  (T && (n || s) && t.manuallyAnimateOnMount && (T = !1),
                  (y.protectedKeys = { ...d }),
                  (!y.isActive && null === w) ||
                    (!g && !y.prevProp) ||
                    (0, D.N)(g) ||
                    "boolean" == typeof g)
                )
                  continue;
                if ("exit" === f && y.isActive && !0 !== w) {
                  y.prevResolvedValues && (d = { ...d, ...y.prevResolvedValues });
                  continue;
                }
                let b =
                    ((p = y.prevProp),
                    "string" == typeof (m = g) ? m !== p : !!Array.isArray(m) && !ti(m, p)),
                  S = b || (f === o && y.isActive && !T && x) || (e > c && x),
                  P = !1,
                  A = Array.isArray(g) ? g : [g],
                  E = A.reduce(r(f), {});
                !1 === w && (E = {});
                let { prevResolvedValues: M = {} } = y,
                  k = { ...M, ...E },
                  V = (e) => {
                    ((S = !0), u.has(e) && ((P = !0), u.delete(e)), (y.needsAnimating[e] = !0));
                    let i = t.getValue(e);
                    i && (i.liveStyle = !1);
                  };
                for (let t in k) {
                  let e = E[t],
                    i = M[t];
                  if (!d.hasOwnProperty(t))
                    ((0, te.p)(e) && (0, te.p)(i) ? ti(e, i) : e === i)
                      ? void 0 !== e && u.has(t)
                        ? V(t)
                        : (y.protectedKeys[t] = !0)
                      : null != e
                        ? V(t)
                        : u.add(t);
                }
                ((y.prevProp = g),
                  (y.prevResolvedValues = E),
                  y.isActive && (d = { ...d, ...E }),
                  (n || s) && t.blockInitialAnimation && (S = !1));
                let C = T && b,
                  R = !C || P;
                S &&
                  R &&
                  h.push(
                    ...A.map((e) => {
                      let i = { type: f };
                      if (
                        "string" == typeof e &&
                        (n || s) &&
                        !C &&
                        t.manuallyAnimateOnMount &&
                        t.parent
                      ) {
                        let { parent: n } = t,
                          s = (0, Y.K)(n, e);
                        if (n.enteringChildren && s) {
                          let { delayChildren: e } = s.transition || {};
                          i.delay = _(n.enteringChildren, t, e);
                        }
                      }
                      return { animation: e, options: i };
                    }),
                  );
              }
              if (u.size) {
                let e = {};
                if ("boolean" != typeof a.initial) {
                  let i = (0, Y.K)(t, Array.isArray(a.initial) ? a.initial[0] : a.initial);
                  i && i.transition && (e.transition = i.transition);
                }
                (u.forEach((i) => {
                  let n = t.getBaseTarget(i),
                    s = t.getValue(i);
                  (s && (s.liveStyle = !0), (e[i] = n ?? null));
                }),
                  h.push({ animation: e }));
              }
              let f = !!h.length;
              return (
                n &&
                  (!1 === a.initial || a.initial === a.animate) &&
                  !t.manuallyAnimateOnMount &&
                  (f = !1),
                (n = !1),
                (s = !1),
                f ? e(h) : Promise.resolve()
              );
            }
            return {
              animateChanges: o,
              setActive: function (e, n) {
                if (i[e].isActive === n) return Promise.resolve();
                (t.variantChildren?.forEach((t) => t.animationState?.setActive(e, n)),
                  (i[e].isActive = n));
                let s = o(e);
                for (let t in i) i[t].protectedKeys = {};
                return s;
              },
              setAnimateFunction: function (i) {
                e = i(t);
              },
              getState: () => i,
              reset: () => {
                ((i = to()), (s = !0));
              },
            };
          })(t)));
    }
    updateAnimationControlsSubscription() {
      let { animate: t } = this.node.getProps();
      (0, D.N)(t) && (this.unmountControls = t.subscribe(this.node));
    }
    mount() {
      this.updateAnimationControlsSubscription();
    }
    update() {
      let { animate: t } = this.node.getProps(),
        { animate: e } = this.node.prevProps || {};
      t !== e && this.updateAnimationControlsSubscription();
    }
    unmount() {
      (this.node.animationState.reset(), this.unmountControls?.());
    }
  }
  let tl = 0;
  class th extends z {
    constructor() {
      (super(...arguments), (this.id = tl++), (this.isExitComplete = !1));
    }
    update() {
      if (!this.node.presenceContext) return;
      let { isPresent: t, onExitComplete: e } = this.node.presenceContext,
        { isPresent: i } = this.node.prevPresenceContext || {};
      if (!this.node.animationState || t === i) return;
      if (t && !1 === i) {
        if (this.isExitComplete) {
          let { initial: t, custom: e } = this.node.getProps();
          if ("string" == typeof t) {
            let i = (0, Y.K)(this.node, t, e);
            if (i) {
              let { transition: t, transitionEnd: e, ...n } = i;
              for (let t in n) this.node.getValue(t)?.jump(n[t]);
            }
          }
          (this.node.animationState.reset(), this.node.animationState.animateChanges());
        } else this.node.animationState.setActive("exit", !1);
        this.isExitComplete = !1;
        return;
      }
      let n = this.node.animationState.setActive("exit", !t);
      e &&
        !t &&
        n.then(() => {
          ((this.isExitComplete = !0), e(this.id));
        });
    }
    mount() {
      let { register: t, onExitComplete: e } = this.node.presenceContext || {};
      (e && e(this.id), t && (this.unmount = t(this.id)));
    }
    unmount() {}
  }
  var tu = i(6500),
    td = i(39622);
  let tc = { x: !1, y: !1 };
  function tp(t) {
    return [t("x"), t("y")];
  }
  var tm = i(92419),
    tf = i(39361);
  function tv(t) {
    return t.max - t.min;
  }
  function ty(t, e, i, n = 0.5) {
    ((t.origin = n),
      (t.originPoint = (0, tf.k)(e.min, e.max, t.origin)),
      (t.scale = tv(i) / tv(e)),
      (t.translate = (0, tf.k)(i.min, i.max, t.origin) - t.originPoint),
      ((t.scale >= 0.9999 && t.scale <= 1.0001) || isNaN(t.scale)) && (t.scale = 1),
      ((t.translate >= -0.01 && t.translate <= 0.01) || isNaN(t.translate)) && (t.translate = 0));
  }
  function tg(t, e, i, n) {
    (ty(t.x, e.x, i.x, n ? n.originX : void 0), ty(t.y, e.y, i.y, n ? n.originY : void 0));
  }
  function tx(t, e, i, n = 0) {
    ((t.min = (n ? (0, tf.k)(i.min, i.max, n) : i.min) + e.min), (t.max = t.min + tv(e)));
  }
  function tw(t, e, i, n = 0) {
    let s = n ? (0, tf.k)(i.min, i.max, n) : i.min;
    ((t.min = e.min - s), (t.max = t.min + tv(e)));
  }
  function tT(t, e, i, n) {
    (tw(t.x, e.x, i.x, n?.x), tw(t.y, e.y, i.y, n?.y));
  }
  var tb = i(73934),
    tS = i(23781),
    tP = i(68745),
    tA = i(33152),
    tE = i(77217);
  let tM = new Set(["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"]),
    tk = new Set(["INPUT", "SELECT", "TEXTAREA"]);
  function tV(t, e, i, n = { passive: !0 }) {
    return (t.addEventListener(e, i, n), () => t.removeEventListener(e, i));
  }
  var tC = i(29089),
    tD = i(38561);
  let tR = new WeakMap(),
    tL = (t, e, i) => (n, s) =>
      s && s[0] ? s[0][t + "Size"] : (0, tC.x)(n) && "getBBox" in n ? n.getBBox()[e] : n[i],
    tj = tL("inline", "width", "offsetWidth"),
    tB = tL("block", "height", "offsetHeight");
  function tF({ target: t, borderBoxSize: e }) {
    tR.get(t)?.forEach((i) => {
      i(t, {
        get width() {
          return tj(t, e);
        },
        get height() {
          return tB(t, e);
        },
      });
    });
  }
  function tI(t) {
    t.forEach(tF);
  }
  let tO = new Set();
  function tU(t, e) {
    return "function" == typeof t
      ? (tO.add(t),
        s ||
          ((s = () => {
            let t = {
              get width() {
                return window.innerWidth;
              },
              get height() {
                return window.innerHeight;
              },
            };
            tO.forEach((e) => e(t));
          }),
          window.addEventListener("resize", s)),
        () => {
          (tO.delete(t),
            tO.size ||
              "function" != typeof s ||
              (window.removeEventListener("resize", s), (s = void 0)));
        })
      : (function (t, e) {
          n || ("undefined" != typeof ResizeObserver && (n = new ResizeObserver(tI)));
          let i = (0, tD.K)(t);
          return (
            i.forEach((t) => {
              let i = tR.get(t);
              (i || ((i = new Set()), tR.set(t, i)), i.add(e), n?.observe(t));
            }),
            () => {
              i.forEach((t) => {
                let i = tR.get(t);
                (i?.delete(e), i?.size || n?.unobserve(t));
              });
            }
          );
        })(t, e);
  }
  var tW = i(78041);
  let tN = (t) =>
    "mouse" === t.pointerType ? "number" != typeof t.button || t.button <= 0 : !1 !== t.isPrimary;
  function t$(t) {
    return { point: { x: t.pageX, y: t.pageY } };
  }
  function tG(t, e, i, n) {
    return tV(t, e, (t) => tN(t) && i(t, t$(t)), n);
  }
  let tX = ({ current: t }) => (t ? t.ownerDocument.defaultView : null);
  var tq = i(23656),
    tK = i(27290);
  let tH = (t, e) => Math.abs(t - e),
    tz = new Set(["auto", "scroll"]);
  class tY {
    constructor(
      t,
      e,
      {
        transformPagePoint: i,
        contextWindow: n = window,
        dragSnapToOrigin: s = !1,
        distanceThreshold: r = 3,
        element: o,
      } = {},
    ) {
      if (
        ((this.startEvent = null),
        (this.lastMoveEvent = null),
        (this.lastMoveEventInfo = null),
        (this.lastRawMoveEventInfo = null),
        (this.handlers = {}),
        (this.contextWindow = window),
        (this.scrollPositions = new Map()),
        (this.removeScrollListeners = null),
        (this.onElementScroll = (t) => {
          this.handleScroll(t.target);
        }),
        (this.onWindowScroll = () => {
          this.handleScroll(window);
        }),
        (this.updatePoint = () => {
          if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
          this.lastRawMoveEventInfo &&
            (this.lastMoveEventInfo = tQ(this.lastRawMoveEventInfo, this.transformPagePoint));
          let t = tZ(this.lastMoveEventInfo, this.history),
            e = null !== this.startEvent,
            i =
              (function (t, e) {
                return Math.sqrt(tH(t.x, e.x) ** 2 + tH(t.y, e.y) ** 2);
              })(t.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
          if (!e && !i) return;
          let { point: n } = t,
            { timestamp: s } = tb.uv;
          this.history.push({ ...n, timestamp: s });
          let { onStart: r, onMove: o } = this.handlers;
          (e || (r && r(this.lastMoveEvent, t), (this.startEvent = this.lastMoveEvent)),
            o && o(this.lastMoveEvent, t));
        }),
        (this.handlePointerMove = (t, e) => {
          ((this.lastMoveEvent = t),
            (this.lastRawMoveEventInfo = e),
            (this.lastMoveEventInfo = tQ(e, this.transformPagePoint)),
            tb.Gt.update(this.updatePoint, !0));
        }),
        (this.handlePointerUp = (t, e) => {
          this.end();
          let { onEnd: i, onSessionEnd: n, resumeAnimation: s } = this.handlers;
          if (
            ((this.dragSnapToOrigin || !this.startEvent) && s && s(),
            !(this.lastMoveEvent && this.lastMoveEventInfo))
          )
            return;
          let r = tZ(
            "pointercancel" === t.type ? this.lastMoveEventInfo : tQ(e, this.transformPagePoint),
            this.history,
          );
          (this.startEvent && i && i(t, r), n && n(t, r));
        }),
        !tN(t))
      )
        return;
      ((this.dragSnapToOrigin = s),
        (this.handlers = e),
        (this.transformPagePoint = i),
        (this.distanceThreshold = r),
        (this.contextWindow = n || window));
      let a = tQ(t$(t), this.transformPagePoint),
        { point: l } = a,
        { timestamp: h } = tb.uv;
      this.history = [{ ...l, timestamp: h }];
      let { onSessionStart: u } = e;
      (u && u(t, tZ(a, this.history)),
        (this.removeListeners = (0, tq.F)(
          tG(this.contextWindow, "pointermove", this.handlePointerMove),
          tG(this.contextWindow, "pointerup", this.handlePointerUp),
          tG(this.contextWindow, "pointercancel", this.handlePointerUp),
        )),
        o && this.startScrollTracking(o));
    }
    startScrollTracking(t) {
      let e = t.parentElement;
      for (; e; ) {
        let t = getComputedStyle(e);
        ((tz.has(t.overflowX) || tz.has(t.overflowY)) &&
          this.scrollPositions.set(e, { x: e.scrollLeft, y: e.scrollTop }),
          (e = e.parentElement));
      }
      (this.scrollPositions.set(window, { x: window.scrollX, y: window.scrollY }),
        window.addEventListener("scroll", this.onElementScroll, { capture: !0 }),
        window.addEventListener("scroll", this.onWindowScroll),
        (this.removeScrollListeners = () => {
          (window.removeEventListener("scroll", this.onElementScroll, { capture: !0 }),
            window.removeEventListener("scroll", this.onWindowScroll));
        }));
    }
    handleScroll(t) {
      let e = this.scrollPositions.get(t);
      if (!e) return;
      let i = t === window,
        n = i ? { x: window.scrollX, y: window.scrollY } : { x: t.scrollLeft, y: t.scrollTop },
        s = { x: n.x - e.x, y: n.y - e.y };
      (0 !== s.x || 0 !== s.y) &&
        (i
          ? this.lastMoveEventInfo &&
            ((this.lastMoveEventInfo.point.x += s.x), (this.lastMoveEventInfo.point.y += s.y))
          : this.history.length > 0 && ((this.history[0].x -= s.x), (this.history[0].y -= s.y)),
        this.scrollPositions.set(t, n),
        tb.Gt.update(this.updatePoint, !0));
    }
    updateHandlers(t) {
      this.handlers = t;
    }
    end() {
      (this.removeListeners && this.removeListeners(),
        this.removeScrollListeners && this.removeScrollListeners(),
        this.scrollPositions.clear(),
        (0, tb.WG)(this.updatePoint));
    }
  }
  function tQ(t, e) {
    return e ? { point: e(t.point) } : t;
  }
  function t_(t, e) {
    return { x: t.x - e.x, y: t.y - e.y };
  }
  function tZ({ point: t }, e) {
    return {
      point: t,
      delta: t_(t, tJ(e)),
      offset: t_(t, e[0]),
      velocity: (function (t, e) {
        if (t.length < 2) return { x: 0, y: 0 };
        let i = t.length - 1,
          n = null,
          s = tJ(t);
        for (; i >= 0 && ((n = t[i]), !(s.timestamp - n.timestamp > (0, tK.f)(0.1))); ) i--;
        if (!n) return { x: 0, y: 0 };
        n === t[0] && t.length > 2 && s.timestamp - n.timestamp > 2 * (0, tK.f)(e) && (n = t[1]);
        let r = (0, tK.X)(s.timestamp - n.timestamp);
        if (0 === r) return { x: 0, y: 0 };
        let o = { x: (s.x - n.x) / r, y: (s.y - n.y) / r };
        return (o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o);
      })(e, 0.1),
    };
  }
  function tJ(t) {
    return t[t.length - 1];
  }
  var t0 = i(91225),
    t1 = i(48895);
  function t3(t, e, i) {
    return {
      min: void 0 !== e ? t.min + e : void 0,
      max: void 0 !== i ? t.max + i - (t.max - t.min) : void 0,
    };
  }
  function t2(t, e) {
    let i = e.min - t.min,
      n = e.max - t.max;
    return (e.max - e.min < t.max - t.min && ([i, n] = [n, i]), { min: i, max: n });
  }
  function t8(t, e, i) {
    return { min: t5(t, e), max: t5(t, i) };
  }
  function t5(t, e) {
    return "number" == typeof t ? t : t[e] || 0;
  }
  let t4 = new WeakMap();
  class t9 {
    constructor(t) {
      ((this.openDragLock = null),
        (this.isDragging = !1),
        (this.currentDirection = null),
        (this.originPoint = { x: 0, y: 0 }),
        (this.constraints = !1),
        (this.hasMutatedConstraints = !1),
        (this.elastic = (0, td.ge)()),
        (this.latestPointerEvent = null),
        (this.latestPanInfo = null),
        (this.visualElement = t));
    }
    start(t, { snapToCursor: e = !1, distanceThreshold: i } = {}) {
      let { presenceContext: n } = this.visualElement;
      if (n && !1 === n.isPresent) return;
      let s = (t) => {
          (e && this.snapToCursor(t$(t).point), this.stopAnimation());
        },
        r = (t, e) => {
          let { drag: i, dragPropagation: n, onDragStart: s } = this.getProps();
          if (
            i &&
            !n &&
            (this.openDragLock && this.openDragLock(),
            (this.openDragLock = (function (t) {
              if ("x" === t || "y" === t)
                if (tc[t]) return null;
                else
                  return (
                    (tc[t] = !0),
                    () => {
                      tc[t] = !1;
                    }
                  );
              return tc.x || tc.y
                ? null
                : ((tc.x = tc.y = !0),
                  () => {
                    tc.x = tc.y = !1;
                  });
            })(i)),
            !this.openDragLock)
          )
            return;
          ((this.latestPointerEvent = t),
            (this.latestPanInfo = e),
            (this.isDragging = !0),
            (this.currentDirection = null),
            this.resolveConstraints(),
            this.visualElement.projection &&
              ((this.visualElement.projection.isAnimationBlocked = !0),
              (this.visualElement.projection.target = void 0)),
            tp((t) => {
              let e = this.getAxisMotionValue(t).get() || 0;
              if (tm.KN.test(e)) {
                let { projection: i } = this.visualElement;
                if (i && i.layout) {
                  let n = i.layout.layoutBox[t];
                  n && (e = tv(n) * (parseFloat(e) / 100));
                }
              }
              this.originPoint[t] = e;
            }),
            s && tb.Gt.update(() => s(t, e), !1, !0),
            (0, tS.g)(this.visualElement, "transform"));
          let { animationState: r } = this.visualElement;
          r && r.setActive("whileDrag", !0);
        },
        o = (t, e) => {
          ((this.latestPointerEvent = t), (this.latestPanInfo = e));
          let {
            dragPropagation: i,
            dragDirectionLock: n,
            onDirectionLock: s,
            onDrag: r,
          } = this.getProps();
          if (!i && !this.openDragLock) return;
          let { offset: o } = e;
          if (n && null === this.currentDirection) {
            ((this.currentDirection = (function (t, e = 10) {
              let i = null;
              return (Math.abs(t.y) > e ? (i = "y") : Math.abs(t.x) > e && (i = "x"), i);
            })(o)),
              null !== this.currentDirection && s && s(this.currentDirection));
            return;
          }
          (this.updateAxis("x", e.point, o),
            this.updateAxis("y", e.point, o),
            this.visualElement.render(),
            r && tb.Gt.update(() => r(t, e), !1, !0));
        },
        a = (t, e) => {
          ((this.latestPointerEvent = t),
            (this.latestPanInfo = e),
            this.stop(t, e),
            (this.latestPointerEvent = null),
            (this.latestPanInfo = null));
        },
        l = () => {
          let { dragSnapToOrigin: t } = this.getProps();
          (t || this.constraints) && this.startAnimation({ x: 0, y: 0 });
        },
        { dragSnapToOrigin: h } = this.getProps();
      this.panSession = new tY(
        t,
        { onSessionStart: s, onStart: r, onMove: o, onSessionEnd: a, resumeAnimation: l },
        {
          transformPagePoint: this.visualElement.getTransformPagePoint(),
          dragSnapToOrigin: h,
          distanceThreshold: i,
          contextWindow: tX(this.visualElement),
          element: this.visualElement.current,
        },
      );
    }
    stop(t, e) {
      let i = t || this.latestPointerEvent,
        n = e || this.latestPanInfo,
        s = this.isDragging;
      if ((this.cancel(), !s || !n || !i)) return;
      let { velocity: r } = n;
      this.startAnimation(r);
      let { onDragEnd: o } = this.getProps();
      o && tb.Gt.postRender(() => o(i, n));
    }
    cancel() {
      this.isDragging = !1;
      let { projection: t, animationState: e } = this.visualElement;
      (t && (t.isAnimationBlocked = !1), this.endPanSession());
      let { dragPropagation: i } = this.getProps();
      (!i && this.openDragLock && (this.openDragLock(), (this.openDragLock = null)),
        e && e.setActive("whileDrag", !1));
    }
    endPanSession() {
      (this.panSession && this.panSession.end(), (this.panSession = void 0));
    }
    updateAxis(t, e, i) {
      let { drag: n } = this.getProps();
      if (!i || !t7(t, n, this.currentDirection)) return;
      let s = this.getAxisMotionValue(t),
        r = this.originPoint[t] + i[t];
      (this.constraints &&
        this.constraints[t] &&
        (r = (function (t, { min: e, max: i }, n) {
          return (
            void 0 !== e && t < e
              ? (t = n ? (0, tf.k)(e, t, n.min) : Math.max(t, e))
              : void 0 !== i && t > i && (t = n ? (0, tf.k)(i, t, n.max) : Math.min(t, i)),
            t
          );
        })(r, this.constraints[t], this.elastic[t])),
        s.set(r));
    }
    resolveConstraints() {
      let { dragConstraints: t, dragElastic: e } = this.getProps(),
        i =
          this.visualElement.projection && !this.visualElement.projection.layout
            ? this.visualElement.projection.measure(!1)
            : this.visualElement.projection?.layout,
        n = this.constraints;
      (t && q(t)
        ? this.constraints || (this.constraints = this.resolveRefConstraints())
        : t && i
          ? (this.constraints = (function (t, { top: e, left: i, bottom: n, right: s }) {
              return { x: t3(t.x, i, s), y: t3(t.y, e, n) };
            })(i.layoutBox, t))
          : (this.constraints = !1),
        (this.elastic = (function (t = 0.35) {
          return (
            !1 === t ? (t = 0) : !0 === t && (t = 0.35),
            { x: t8(t, "left", "right"), y: t8(t, "top", "bottom") }
          );
        })(e)),
        n !== this.constraints &&
          !q(t) &&
          i &&
          this.constraints &&
          !this.hasMutatedConstraints &&
          tp((t) => {
            !1 !== this.constraints &&
              this.getAxisMotionValue(t) &&
              (this.constraints[t] = (function (t, e) {
                let i = {};
                return (
                  void 0 !== e.min && (i.min = e.min - t.min),
                  void 0 !== e.max && (i.max = e.max - t.min),
                  i
                );
              })(i.layoutBox[t], this.constraints[t]));
          }));
    }
    resolveRefConstraints() {
      var t;
      let { dragConstraints: e, onMeasureDragConstraints: i } = this.getProps();
      if (!e || !q(e)) return !1;
      let n = e.current;
      (0, tW.V)(
        null !== n,
        "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.",
        "drag-constraints-ref",
      );
      let { projection: s } = this.visualElement;
      if (!s || !s.layout) return !1;
      let r = (0, tP.L)(n, s.root, this.visualElement.getTransformPagePoint()),
        o = ((t = s.layout.layoutBox), { x: t2(t.x, r.x), y: t2(t.y, r.y) });
      if (i) {
        let t = i((0, tA.pA)(o));
        ((this.hasMutatedConstraints = !!t), t && (o = (0, tA.FY)(t)));
      }
      return o;
    }
    startAnimation(t) {
      let {
          drag: e,
          dragMomentum: i,
          dragElastic: n,
          dragTransition: s,
          dragSnapToOrigin: r,
          onDragTransitionEnd: o,
        } = this.getProps(),
        a = this.constraints || {};
      return Promise.all(
        tp((o) => {
          if (!t7(o, e, this.currentDirection)) return;
          let l = (a && a[o]) || {};
          (!0 === r || r === o) && (l = { min: 0, max: 0 });
          let h = {
            type: "inertia",
            velocity: i ? t[o] : 0,
            bounceStiffness: n ? 200 : 1e6,
            bounceDamping: n ? 40 : 1e7,
            timeConstant: 750,
            restDelta: 1,
            restSpeed: 10,
            ...s,
            ...l,
          };
          return this.startAxisValueAnimation(o, h);
        }),
      ).then(o);
    }
    startAxisValueAnimation(t, e) {
      let i = this.getAxisMotionValue(t);
      return (
        (0, tS.g)(this.visualElement, t),
        i.start((0, tE.f)(t, i, 0, e, this.visualElement, !1))
      );
    }
    stopAnimation() {
      tp((t) => this.getAxisMotionValue(t).stop());
    }
    getAxisMotionValue(t) {
      let e = `_drag${t.toUpperCase()}`,
        i = this.visualElement.getProps();
      return i[e] || this.visualElement.getValue(t, (i.initial ? i.initial[t] : void 0) || 0);
    }
    snapToCursor(t) {
      tp((e) => {
        let { drag: i } = this.getProps();
        if (!t7(e, i, this.currentDirection)) return;
        let { projection: n } = this.visualElement,
          s = this.getAxisMotionValue(e);
        if (n && n.layout) {
          let { min: i, max: r } = n.layout.layoutBox[e],
            o = s.get() || 0;
          s.set(t[e] - (0, tf.k)(i, r, 0.5) + o);
        }
      });
    }
    scalePositionWithinConstraints() {
      if (!this.visualElement.current) return;
      let { drag: t, dragConstraints: e } = this.getProps(),
        { projection: i } = this.visualElement;
      if (!q(e) || !i || !this.constraints) return;
      this.stopAnimation();
      let n = { x: 0, y: 0 };
      tp((t) => {
        let e = this.getAxisMotionValue(t);
        if (e && !1 !== this.constraints) {
          let i = e.get();
          n[t] = (function (t, e) {
            let i = 0.5,
              n = tv(t),
              s = tv(e);
            return (
              s > n
                ? (i = (0, t0.q)(e.min, e.max - n, t.min))
                : n > s && (i = (0, t0.q)(t.min, t.max - s, e.min)),
              (0, t1.q)(0, 1, i)
            );
          })({ min: i, max: i }, this.constraints[t]);
        }
      });
      let { transformTemplate: s } = this.visualElement.getProps();
      ((this.visualElement.current.style.transform = s ? s({}, "") : "none"),
        i.root && i.root.updateScroll(),
        i.updateLayout(),
        (this.constraints = !1),
        this.resolveConstraints(),
        tp((e) => {
          if (!t7(e, t, null)) return;
          let i = this.getAxisMotionValue(e),
            { min: s, max: r } = this.constraints[e];
          i.set((0, tf.k)(s, r, n[e]));
        }),
        this.visualElement.render());
    }
    addListeners() {
      let t;
      if (!this.visualElement.current) return;
      t4.set(this.visualElement, this);
      let e = this.visualElement.current,
        i = tG(e, "pointerdown", (t) => {
          let { drag: i, dragListener: n = !0 } = this.getProps(),
            s = t.target,
            r = s !== e && (tk.has(s.tagName) || !0 === s.isContentEditable);
          i && n && !r && this.start(t);
        }),
        n = () => {
          let { dragConstraints: i } = this.getProps();
          q(i) &&
            i.current &&
            ((this.constraints = this.resolveRefConstraints()),
            t ||
              (t = (function (t, e, i) {
                let n = tU(t, t6(i)),
                  s = tU(e, t6(i));
                return () => {
                  (n(), s());
                };
              })(e, i.current, () => this.scalePositionWithinConstraints())));
        },
        { projection: s } = this.visualElement,
        r = s.addEventListener("measure", n);
      (s && !s.layout && (s.root && s.root.updateScroll(), s.updateLayout()), tb.Gt.read(n));
      let o = tV(window, "resize", () => this.scalePositionWithinConstraints()),
        a = s.addEventListener("didUpdate", ({ delta: t, hasLayoutChanged: e }) => {
          this.isDragging &&
            e &&
            (tp((e) => {
              let i = this.getAxisMotionValue(e);
              i && ((this.originPoint[e] += t[e].translate), i.set(i.get() + t[e].translate));
            }),
            this.visualElement.render());
        });
      return () => {
        (o(), i(), r(), a && a(), t && t());
      };
    }
    getProps() {
      let t = this.visualElement.getProps(),
        {
          drag: e = !1,
          dragDirectionLock: i = !1,
          dragPropagation: n = !1,
          dragConstraints: s = !1,
          dragElastic: r = 0.35,
          dragMomentum: o = !0,
        } = t;
      return {
        ...t,
        drag: e,
        dragDirectionLock: i,
        dragPropagation: n,
        dragConstraints: s,
        dragElastic: r,
        dragMomentum: o,
      };
    }
  }
  function t6(t) {
    let e = !0;
    return () => {
      if (e) {
        e = !1;
        return;
      }
      t();
    };
  }
  function t7(t, e, i) {
    return (!0 === e || e === t) && (null === i || i === t);
  }
  class et extends z {
    constructor(t) {
      (super(t),
        (this.removeGroupControls = tu.l),
        (this.removeListeners = tu.l),
        (this.controls = new t9(t)));
    }
    mount() {
      let { dragControls: t } = this.node.getProps();
      (t && (this.removeGroupControls = t.subscribe(this.controls)),
        (this.removeListeners = this.controls.addListeners() || tu.l));
    }
    update() {
      let { dragControls: t } = this.node.getProps(),
        { dragControls: e } = this.node.prevProps || {};
      t !== e &&
        (this.removeGroupControls(), t && (this.removeGroupControls = t.subscribe(this.controls)));
    }
    unmount() {
      (this.removeGroupControls(),
        this.removeListeners(),
        this.controls.isDragging || this.controls.endPanSession());
    }
  }
  let ee = (t) => (e, i) => {
    t && tb.Gt.update(() => t(e, i), !1, !0);
  };
  class ei extends z {
    constructor() {
      (super(...arguments), (this.removePointerDownListener = tu.l));
    }
    onPointerDown(t) {
      this.session = new tY(t, this.createPanHandlers(), {
        transformPagePoint: this.node.getTransformPagePoint(),
        contextWindow: tX(this.node),
      });
    }
    createPanHandlers() {
      let { onPanSessionStart: t, onPanStart: e, onPan: i, onPanEnd: n } = this.node.getProps();
      return {
        onSessionStart: ee(t),
        onStart: ee(e),
        onMove: ee(i),
        onEnd: (t, e) => {
          (delete this.session, n && tb.Gt.postRender(() => n(t, e)));
        },
      };
    }
    mount() {
      this.removePointerDownListener = tG(this.node.current, "pointerdown", (t) =>
        this.onPointerDown(t),
      );
    }
    update() {
      this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
      (this.removePointerDownListener(), this.session && this.session.end());
    }
  }
  let en = { hasAnimatedSinceResize: !0, hasEverUpdated: !1 };
  var es = i(38358),
    er = i(75601);
  let eo = !1;
  class ea extends a.Component {
    componentDidMount() {
      let { visualElement: t, layoutGroup: e, switchLayoutGroup: i, layoutId: n } = this.props,
        { projection: s } = t;
      (s &&
        (e.group && e.group.add(s),
        i && i.register && n && i.register(s),
        eo && s.root.didUpdate(),
        s.addEventListener("animationComplete", () => {
          this.safeToRemove();
        }),
        s.setOptions({
          ...s.options,
          layoutDependency: this.props.layoutDependency,
          onExitComplete: () => this.safeToRemove(),
        })),
        (en.hasEverUpdated = !0));
    }
    getSnapshotBeforeUpdate(t) {
      let { layoutDependency: e, visualElement: i, drag: n, isPresent: s } = this.props,
        { projection: r } = i;
      return (
        r &&
          ((r.isPresent = s),
          t.layoutDependency !== e && r.setOptions({ ...r.options, layoutDependency: e }),
          (eo = !0),
          n || t.layoutDependency !== e || void 0 === e || t.isPresent !== s
            ? r.willUpdate()
            : this.safeToRemove(),
          t.isPresent !== s &&
            (s
              ? r.promote()
              : r.relegate() ||
                tb.Gt.postRender(() => {
                  let t = r.getStack();
                  (t && t.members.length) || this.safeToRemove();
                }))),
        null
      );
    }
    componentDidUpdate() {
      let { visualElement: t, layoutAnchor: e } = this.props,
        { projection: i } = t;
      i &&
        ((i.options.layoutAnchor = e),
        i.root.didUpdate(),
        es.k.postRender(() => {
          !i.currentAnimation && i.isLead() && this.safeToRemove();
        }));
    }
    componentWillUnmount() {
      let { visualElement: t, layoutGroup: e, switchLayoutGroup: i } = this.props,
        { projection: n } = t;
      ((eo = !0),
        n &&
          (n.scheduleCheckAfterUnmount(),
          e && e.group && e.group.remove(n),
          i && i.deregister && i.deregister(n)));
    }
    safeToRemove() {
      let { safeToRemove: t } = this.props;
      t && t();
    }
    render() {
      return null;
    }
  }
  function el(t) {
    let [e, i] = (0, er.xQ)(),
      n = (0, a.useContext)(d.L);
    return (0, u.jsx)(ea, {
      ...t,
      layoutGroup: n,
      switchLayoutGroup: (0, a.useContext)(X),
      isPresent: e,
      safeToRemove: i,
    });
  }
  var eh = i(8453),
    eu = i(78616),
    ed = i(60738),
    ec = i(63354),
    ep = i(27424),
    em = i(45385),
    ef = i(62213),
    ev = i(23867),
    ey = i(25188),
    eg = i(22039),
    ex = i(69809);
  let ew = [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius",
    ],
    eT = ew.length,
    eb = (t) => ("string" == typeof t ? parseFloat(t) : t),
    eS = (t) => "number" == typeof t || tm.px.test(t);
  function eP(t, e) {
    return void 0 !== t[e] ? t[e] : t.borderRadius;
  }
  let eA = eM(0, 0.5, ex.yT),
    eE = eM(0.5, 0.95, tu.l);
  function eM(t, e, i) {
    return (n) => (n < t ? 0 : n > e ? 1 : i((0, t0.q)(t, e, n)));
  }
  function ek(t, e) {
    ((t.min = e.min), (t.max = e.max));
  }
  function eV(t, e) {
    (ek(t.x, e.x), ek(t.y, e.y));
  }
  function eC(t, e) {
    ((t.translate = e.translate),
      (t.scale = e.scale),
      (t.originPoint = e.originPoint),
      (t.origin = e.origin));
  }
  var eD = i(17727);
  function eR(t, e, i, n, s) {
    return (
      (t -= e),
      (t = (0, eD.hq)(t, 1 / i, n)),
      void 0 !== s && (t = (0, eD.hq)(t, 1 / s, n)),
      t
    );
  }
  function eL(t, e, [i, n, s], r, o) {
    !(function (t, e = 0, i = 1, n = 0.5, s, r = t, o = t) {
      if (
        (tm.KN.test(e) && ((e = parseFloat(e)), (e = (0, tf.k)(o.min, o.max, e / 100) - o.min)),
        "number" != typeof e)
      )
        return;
      let a = (0, tf.k)(r.min, r.max, n);
      (t === r && (a -= e), (t.min = eR(t.min, e, i, a, s)), (t.max = eR(t.max, e, i, a, s)));
    })(t, e[i], e[n], e[s], e.scale, r, o);
  }
  let ej = ["x", "scaleX", "originX"],
    eB = ["y", "scaleY", "originY"];
  function eF(t, e, i, n) {
    (eL(t.x, e, ej, i ? i.x : void 0, n ? n.x : void 0),
      eL(t.y, e, eB, i ? i.y : void 0, n ? n.y : void 0));
  }
  function eI(t) {
    return 0 === t.translate && 1 === t.scale;
  }
  function eO(t) {
    return eI(t.x) && eI(t.y);
  }
  function eU(t, e) {
    return t.min === e.min && t.max === e.max;
  }
  function eW(t, e) {
    return Math.round(t.min) === Math.round(e.min) && Math.round(t.max) === Math.round(e.max);
  }
  function eN(t, e) {
    return eW(t.x, e.x) && eW(t.y, e.y);
  }
  function e$(t) {
    return tv(t.x) / tv(t.y);
  }
  function eG(t, e) {
    return t.translate === e.translate && t.scale === e.scale && t.originPoint === e.originPoint;
  }
  var eX = i(16105);
  class eq {
    constructor() {
      this.members = [];
    }
    add(t) {
      (0, eX.Kq)(this.members, t);
      for (let e = this.members.length - 1; e >= 0; e--) {
        let i = this.members[e];
        if (i === t || i === this.lead || i === this.prevLead) continue;
        let n = i.instance;
        (n && !1 !== n.isConnected) || i.snapshot || ((0, eX.Ai)(this.members, i), i.unmount());
      }
      t.scheduleRender();
    }
    remove(t) {
      if (
        ((0, eX.Ai)(this.members, t),
        t === this.prevLead && (this.prevLead = void 0),
        t === this.lead)
      ) {
        let t = this.members[this.members.length - 1];
        t && this.promote(t);
      }
    }
    relegate(t) {
      for (let e = this.members.indexOf(t) - 1; e >= 0; e--) {
        let t = this.members[e];
        if (!1 !== t.isPresent && t.instance?.isConnected !== !1) return (this.promote(t), !0);
      }
      return !1;
    }
    promote(t, e) {
      let i = this.lead;
      if (t !== i && ((this.prevLead = i), (this.lead = t), t.show(), i)) {
        (i.updateSnapshot(), t.scheduleRender());
        let { layoutDependency: n } = i.options,
          { layoutDependency: s } = t.options;
        ((void 0 === n || n !== s) &&
          ((t.resumeFrom = i),
          e && (i.preserveOpacity = !0),
          i.snapshot &&
            ((t.snapshot = i.snapshot),
            (t.snapshot.latestValues = i.animationValues || i.latestValues)),
          t.root?.isUpdating && (t.isLayoutDirty = !0)),
          !1 === t.options.crossfade && i.hide());
      }
    }
    exitAnimationComplete() {
      this.members.forEach((t) => {
        (t.options.onExitComplete?.(), t.resumingFrom?.options.onExitComplete?.());
      });
    }
    scheduleRender() {
      this.members.forEach((t) => t.instance && t.scheduleRender(!1));
    }
    removeLeadSnapshot() {
      this.lead?.snapshot && (this.lead.snapshot = void 0);
    }
  }
  let eK = (t, e) => t.depth - e.depth;
  class eH {
    constructor() {
      ((this.children = []), (this.isDirty = !1));
    }
    add(t) {
      ((0, eX.Kq)(this.children, t), (this.isDirty = !0));
    }
    remove(t) {
      ((0, eX.Ai)(this.children, t), (this.isDirty = !0));
    }
    forEach(t) {
      (this.isDirty && this.children.sort(eK), (this.isDirty = !1), this.children.forEach(t));
    }
  }
  var ez = i(42418);
  let eY = { nodes: 0, calculatedTargetDeltas: 0, calculatedProjections: 0 },
    eQ = ["", "X", "Y", "Z"],
    e_ = 0;
  function eZ(t, e, i, n) {
    let { latestValues: s } = e;
    s[t] && ((i[t] = s[t]), e.setStaticValue(t, 0), n && (n[t] = 0));
  }
  function eJ({
    attachResizeListener: t,
    defaultParent: e,
    measureScroll: i,
    checkIsScrollRoot: n,
    resetTransform: s,
  }) {
    return class {
      constructor(t = {}, i = e?.()) {
        ((this.id = e_++),
          (this.animationId = 0),
          (this.animationCommitId = 0),
          (this.children = new Set()),
          (this.options = {}),
          (this.isTreeAnimating = !1),
          (this.isAnimationBlocked = !1),
          (this.isLayoutDirty = !1),
          (this.isProjectionDirty = !1),
          (this.isSharedProjectionDirty = !1),
          (this.isTransformDirty = !1),
          (this.updateManuallyBlocked = !1),
          (this.updateBlockedByResize = !1),
          (this.isUpdating = !1),
          (this.isSVG = !1),
          (this.needsReset = !1),
          (this.shouldResetTransform = !1),
          (this.hasCheckedOptimisedAppear = !1),
          (this.treeScale = { x: 1, y: 1 }),
          (this.eventHandlers = new Map()),
          (this.hasTreeAnimated = !1),
          (this.layoutVersion = 0),
          (this.updateScheduled = !1),
          (this.scheduleUpdate = () => this.update()),
          (this.projectionUpdateScheduled = !1),
          (this.checkUpdateFailed = () => {
            this.isUpdating && ((this.isUpdating = !1), this.clearAllSnapshots());
          }),
          (this.updateProjection = () => {
            ((this.projectionUpdateScheduled = !1),
              ev.Q.value && (eY.nodes = eY.calculatedTargetDeltas = eY.calculatedProjections = 0),
              this.nodes.forEach(e3),
              this.nodes.forEach(ie),
              this.nodes.forEach(ii),
              this.nodes.forEach(e2),
              ev.Q.addProjectionMetrics && ev.Q.addProjectionMetrics(eY));
          }),
          (this.resolvedRelativeTargetAt = 0),
          (this.linkedParentVersion = 0),
          (this.hasProjected = !1),
          (this.isVisible = !0),
          (this.animationProgress = 0),
          (this.sharedNodes = new Map()),
          (this.latestValues = t),
          (this.root = i ? i.root || i : this),
          (this.path = i ? [...i.path, i] : []),
          (this.parent = i),
          (this.depth = i ? i.depth + 1 : 0));
        for (let t = 0; t < this.path.length; t++) this.path[t].shouldResetTransform = !0;
        this.root === this && (this.nodes = new eH());
      }
      addEventListener(t, e) {
        return (
          this.eventHandlers.has(t) || this.eventHandlers.set(t, new eh.v()),
          this.eventHandlers.get(t).add(e)
        );
      }
      notifyListeners(t, ...e) {
        let i = this.eventHandlers.get(t);
        i && i.notify(...e);
      }
      hasListeners(t) {
        return this.eventHandlers.has(t);
      }
      mount(e) {
        if (this.instance) return;
        ((this.isSVG = (0, tC.x)(e) && !(0, ey.h)(e)), (this.instance = e));
        let { layoutId: i, layout: n, visualElement: s } = this.options;
        if (
          (s && !s.current && s.mount(e),
          this.root.nodes.add(this),
          this.parent && this.parent.children.add(this),
          this.root.hasTreeAnimated && (n || i) && (this.isLayoutDirty = !0),
          t)
        ) {
          let i,
            n = 0,
            s = () => (this.root.updateBlockedByResize = !1);
          (tb.Gt.read(() => {
            n = window.innerWidth;
          }),
            t(e, () => {
              let t = window.innerWidth;
              t !== n &&
                ((n = t),
                (this.root.updateBlockedByResize = !0),
                i && i(),
                (i = (function (t, e) {
                  let i = ep.k.now(),
                    n = ({ timestamp: e }) => {
                      let s = e - i;
                      s >= 250 && ((0, tb.WG)(n), t(s - 250));
                    };
                  return (tb.Gt.setup(n, !0), () => (0, tb.WG)(n));
                })(s, 250)),
                en.hasAnimatedSinceResize &&
                  ((en.hasAnimatedSinceResize = !1), this.nodes.forEach(it)));
            }));
        }
        (i && this.root.registerSharedNode(i, this),
          !1 !== this.options.animate &&
            s &&
            (i || n) &&
            this.addEventListener(
              "didUpdate",
              ({ delta: t, hasLayoutChanged: e, hasRelativeLayoutChanged: i, layout: n }) => {
                if (this.isTreeAnimationBlocked()) {
                  ((this.target = void 0), (this.relativeTarget = void 0));
                  return;
                }
                let r = this.options.transition || s.getDefaultTransition() || ih,
                  { onLayoutAnimationStart: o, onLayoutAnimationComplete: a } = s.getProps(),
                  l = !this.targetLayout || !eN(this.targetLayout, n),
                  h = !e && i;
                if (
                  this.options.layoutRoot ||
                  this.resumeFrom ||
                  h ||
                  (e && (l || !this.currentAnimation))
                ) {
                  this.resumeFrom &&
                    ((this.resumingFrom = this.resumeFrom),
                    (this.resumingFrom.resumingFrom = void 0));
                  let e = { ...(0, ec.r)(r, "layout"), onPlay: o, onComplete: a };
                  ((s.shouldReduceMotion || this.options.layoutRoot) &&
                    ((e.delay = 0), (e.type = !1)),
                    this.startAnimation(e),
                    this.setAnimationOrigin(t, h));
                } else
                  (e || it(this),
                    this.isLead() && this.options.onExitComplete && this.options.onExitComplete());
                this.targetLayout = n;
              },
            ));
      }
      unmount() {
        (this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this));
        let t = this.getStack();
        (t && t.remove(this),
          this.parent && this.parent.children.delete(this),
          (this.instance = void 0),
          this.eventHandlers.clear(),
          (0, tb.WG)(this.updateProjection));
      }
      blockUpdate() {
        this.updateManuallyBlocked = !0;
      }
      unblockUpdate() {
        this.updateManuallyBlocked = !1;
      }
      isUpdateBlocked() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }
      isTreeAnimationBlocked() {
        return (
          this.isAnimationBlocked || (this.parent && this.parent.isTreeAnimationBlocked()) || !1
        );
      }
      startUpdate() {
        !this.isUpdateBlocked() &&
          ((this.isUpdating = !0), this.nodes && this.nodes.forEach(is), this.animationId++);
      }
      getTransformTemplate() {
        let { visualElement: t } = this.options;
        return t && t.getProps().transformTemplate;
      }
      willUpdate(t = !0) {
        if (((this.root.hasTreeAnimated = !0), this.root.isUpdateBlocked())) {
          this.options.onExitComplete && this.options.onExitComplete();
          return;
        }
        if (
          (window.MotionCancelOptimisedAnimation &&
            !this.hasCheckedOptimisedAppear &&
            (function t(e) {
              if (((e.hasCheckedOptimisedAppear = !0), e.root === e)) return;
              let { visualElement: i } = e.options;
              if (!i) return;
              let n = (0, ed.P)(i);
              if (window.MotionHasOptimisedAnimation(n, "transform")) {
                let { layout: t, layoutId: i } = e.options;
                window.MotionCancelOptimisedAnimation(n, "transform", tb.Gt, !(t || i));
              }
              let { parent: s } = e;
              s && !s.hasCheckedOptimisedAppear && t(s);
            })(this),
          this.root.isUpdating || this.root.startUpdate(),
          this.isLayoutDirty)
        )
          return;
        this.isLayoutDirty = !0;
        for (let t = 0; t < this.path.length; t++) {
          let e = this.path[t];
          ((e.shouldResetTransform = !0),
            ("string" == typeof e.latestValues.x || "string" == typeof e.latestValues.y) &&
              (e.isLayoutDirty = !0),
            e.updateScroll("snapshot"),
            e.options.layoutRoot && e.willUpdate(!1));
        }
        let { layoutId: e, layout: i } = this.options;
        if (void 0 === e && !i) return;
        let n = this.getTransformTemplate();
        ((this.prevTransformTemplateValue = n ? n(this.latestValues, "") : void 0),
          this.updateSnapshot(),
          t && this.notifyListeners("willUpdate"));
      }
      update() {
        if (((this.updateScheduled = !1), this.isUpdateBlocked())) {
          let t = this.updateBlockedByResize;
          (this.unblockUpdate(),
            (this.updateBlockedByResize = !1),
            this.clearAllSnapshots(),
            t && this.nodes.forEach(e4),
            this.nodes.forEach(e5));
          return;
        }
        if (this.animationId <= this.animationCommitId) return void this.nodes.forEach(e9);
        ((this.animationCommitId = this.animationId),
          this.isUpdating
            ? ((this.isUpdating = !1),
              this.nodes.forEach(e6),
              this.nodes.forEach(e7),
              this.nodes.forEach(e0),
              this.nodes.forEach(e1))
            : this.nodes.forEach(e9),
          this.clearAllSnapshots());
        let t = ep.k.now();
        ((tb.uv.delta = (0, t1.q)(0, 1e3 / 60, t - tb.uv.timestamp)),
          (tb.uv.timestamp = t),
          (tb.uv.isProcessing = !0),
          tb.PP.update.process(tb.uv),
          tb.PP.preRender.process(tb.uv),
          tb.PP.render.process(tb.uv),
          (tb.uv.isProcessing = !1));
      }
      didUpdate() {
        this.updateScheduled || ((this.updateScheduled = !0), es.k.read(this.scheduleUpdate));
      }
      clearAllSnapshots() {
        (this.nodes.forEach(e8), this.sharedNodes.forEach(ir));
      }
      scheduleUpdateProjection() {
        this.projectionUpdateScheduled ||
          ((this.projectionUpdateScheduled = !0), tb.Gt.preRender(this.updateProjection, !1, !0));
      }
      scheduleCheckAfterUnmount() {
        tb.Gt.postRender(() => {
          this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
        });
      }
      updateSnapshot() {
        !this.snapshot &&
          this.instance &&
          ((this.snapshot = this.measure()),
          !this.snapshot ||
            tv(this.snapshot.measuredBox.x) ||
            tv(this.snapshot.measuredBox.y) ||
            (this.snapshot = void 0));
      }
      updateLayout() {
        if (
          !this.instance ||
          (this.updateScroll(),
          !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty)
        )
          return;
        if (this.resumeFrom && !this.resumeFrom.instance)
          for (let t = 0; t < this.path.length; t++) this.path[t].updateScroll();
        let t = this.layout;
        ((this.layout = this.measure(!1)),
          this.layoutVersion++,
          this.layoutCorrected || (this.layoutCorrected = (0, td.ge)()),
          (this.isLayoutDirty = !1),
          (this.projectionDelta = void 0),
          this.notifyListeners("measure", this.layout.layoutBox));
        let { visualElement: e } = this.options;
        e && e.notify("LayoutMeasure", this.layout.layoutBox, t ? t.layoutBox : void 0);
      }
      updateScroll(t = "measure") {
        let e = !!(this.options.layoutScroll && this.instance);
        if (
          (this.scroll &&
            this.scroll.animationId === this.root.animationId &&
            this.scroll.phase === t &&
            (e = !1),
          e && this.instance)
        ) {
          let e = n(this.instance);
          this.scroll = {
            animationId: this.root.animationId,
            phase: t,
            isRoot: e,
            offset: i(this.instance),
            wasRoot: this.scroll ? this.scroll.isRoot : e,
          };
        }
      }
      resetTransform() {
        if (!s) return;
        let t = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout,
          e = this.projectionDelta && !eO(this.projectionDelta),
          i = this.getTransformTemplate(),
          n = i ? i(this.latestValues, "") : void 0,
          r = n !== this.prevTransformTemplateValue;
        t &&
          this.instance &&
          (e || (0, ez.HD)(this.latestValues) || r) &&
          (s(this.instance, n), (this.shouldResetTransform = !1), this.scheduleRender());
      }
      measure(t = !0) {
        var e;
        let i = this.measurePageBox(),
          n = this.removeElementScroll(i);
        return (
          t && (n = this.removeTransform(n)),
          ic((e = n).x),
          ic(e.y),
          {
            animationId: this.root.animationId,
            measuredBox: i,
            layoutBox: n,
            latestValues: {},
            source: this.id,
          }
        );
      }
      measurePageBox() {
        let { visualElement: t } = this.options;
        if (!t) return (0, td.ge)();
        let e = t.measureViewportBox();
        if (!(this.scroll?.wasRoot || this.path.some(im))) {
          let { scroll: t } = this.root;
          t && ((0, eD.Ql)(e.x, t.offset.x), (0, eD.Ql)(e.y, t.offset.y));
        }
        return e;
      }
      removeElementScroll(t) {
        let e = (0, td.ge)();
        if ((eV(e, t), this.scroll?.wasRoot)) return e;
        for (let i = 0; i < this.path.length; i++) {
          let n = this.path[i],
            { scroll: s, options: r } = n;
          n !== this.root &&
            s &&
            r.layoutScroll &&
            (s.wasRoot && eV(e, t), (0, eD.Ql)(e.x, s.offset.x), (0, eD.Ql)(e.y, s.offset.y));
        }
        return e;
      }
      applyTransform(t, e = !1, i) {
        let n = i || (0, td.ge)();
        eV(n, t);
        for (let t = 0; t < this.path.length; t++) {
          let i = this.path[t];
          (!e &&
            i.options.layoutScroll &&
            i.scroll &&
            i !== i.root &&
            ((0, eD.Ql)(n.x, -i.scroll.offset.x), (0, eD.Ql)(n.y, -i.scroll.offset.y)),
            (0, ez.HD)(i.latestValues) && (0, eD.Ww)(n, i.latestValues, i.layout?.layoutBox));
        }
        return (
          (0, ez.HD)(this.latestValues) && (0, eD.Ww)(n, this.latestValues, this.layout?.layoutBox),
          n
        );
      }
      removeTransform(t) {
        let e = (0, td.ge)();
        eV(e, t);
        for (let t = 0; t < this.path.length; t++) {
          let i,
            n = this.path[t];
          (0, ez.HD)(n.latestValues) &&
            (n.instance &&
              ((0, ez.vk)(n.latestValues) && n.updateSnapshot(),
              eV((i = (0, td.ge)()), n.measurePageBox())),
            eF(e, n.latestValues, n.snapshot?.layoutBox, i));
        }
        return ((0, ez.HD)(this.latestValues) && eF(e, this.latestValues), e);
      }
      setTargetDelta(t) {
        ((this.targetDelta = t),
          this.root.scheduleUpdateProjection(),
          (this.isProjectionDirty = !0));
      }
      setOptions(t) {
        this.options = { ...this.options, ...t, crossfade: void 0 === t.crossfade || t.crossfade };
      }
      clearMeasurements() {
        ((this.scroll = void 0),
          (this.layout = void 0),
          (this.snapshot = void 0),
          (this.prevTransformTemplateValue = void 0),
          (this.targetDelta = void 0),
          (this.target = void 0),
          (this.isLayoutDirty = !1));
      }
      forceRelativeParentToResolveTarget() {
        this.relativeParent &&
          this.relativeParent.resolvedRelativeTargetAt !== tb.uv.timestamp &&
          this.relativeParent.resolveTargetDelta(!0);
      }
      resolveTargetDelta(t = !1) {
        let e = this.getLead();
        (this.isProjectionDirty || (this.isProjectionDirty = e.isProjectionDirty),
          this.isTransformDirty || (this.isTransformDirty = e.isTransformDirty),
          this.isSharedProjectionDirty ||
            (this.isSharedProjectionDirty = e.isSharedProjectionDirty));
        let i = !!this.resumingFrom || this !== e;
        if (
          !(
            t ||
            (i && this.isSharedProjectionDirty) ||
            this.isProjectionDirty ||
            this.parent?.isProjectionDirty ||
            this.attemptToResolveRelativeTarget ||
            this.root.updateBlockedByResize
          )
        )
          return;
        let { layout: n, layoutId: s } = this.options;
        if (!this.layout || !(n || s)) return;
        this.resolvedRelativeTargetAt = tb.uv.timestamp;
        let r = this.getClosestProjectingParent();
        if (
          (r &&
            this.linkedParentVersion !== r.layoutVersion &&
            !r.options.layoutRoot &&
            this.removeRelativeTarget(),
          this.targetDelta ||
            this.relativeTarget ||
            (!1 !== this.options.layoutAnchor && r && r.layout
              ? this.createRelativeTarget(r, this.layout.layoutBox, r.layout.layoutBox)
              : this.removeRelativeTarget()),
          this.relativeTarget || this.targetDelta)
        ) {
          if (
            (this.target ||
              ((this.target = (0, td.ge)()), (this.targetWithTransforms = (0, td.ge)())),
            this.relativeTarget &&
              this.relativeTargetOrigin &&
              this.relativeParent &&
              this.relativeParent.target)
          ) {
            var o, a, l, h;
            (this.forceRelativeParentToResolveTarget(),
              (o = this.target),
              (a = this.relativeTarget),
              (l = this.relativeParent.target),
              (h = this.options.layoutAnchor || void 0),
              tx(o.x, a.x, l.x, h?.x),
              tx(o.y, a.y, l.y, h?.y));
          } else
            this.targetDelta
              ? (this.resumingFrom
                  ? this.applyTransform(this.layout.layoutBox, !1, this.target)
                  : eV(this.target, this.layout.layoutBox),
                (0, eD.o4)(this.target, this.targetDelta))
              : eV(this.target, this.layout.layoutBox);
          (this.attemptToResolveRelativeTarget &&
            ((this.attemptToResolveRelativeTarget = !1),
            !1 !== this.options.layoutAnchor &&
            r &&
            !!r.resumingFrom == !!this.resumingFrom &&
            !r.options.layoutScroll &&
            r.target &&
            1 !== this.animationProgress
              ? this.createRelativeTarget(r, this.target, r.target)
              : (this.relativeParent = this.relativeTarget = void 0)),
            ev.Q.value && eY.calculatedTargetDeltas++);
        }
      }
      getClosestProjectingParent() {
        if (
          !(
            !this.parent ||
            (0, ez.vk)(this.parent.latestValues) ||
            (0, ez.vF)(this.parent.latestValues)
          )
        )
          if (this.parent.isProjecting()) return this.parent;
          else return this.parent.getClosestProjectingParent();
      }
      isProjecting() {
        return !!(
          (this.relativeTarget || this.targetDelta || this.options.layoutRoot) &&
          this.layout
        );
      }
      createRelativeTarget(t, e, i) {
        ((this.relativeParent = t),
          (this.linkedParentVersion = t.layoutVersion),
          this.forceRelativeParentToResolveTarget(),
          (this.relativeTarget = (0, td.ge)()),
          (this.relativeTargetOrigin = (0, td.ge)()),
          tT(this.relativeTargetOrigin, e, i, this.options.layoutAnchor || void 0),
          eV(this.relativeTarget, this.relativeTargetOrigin));
      }
      removeRelativeTarget() {
        this.relativeParent = this.relativeTarget = void 0;
      }
      calcProjection() {
        let t = this.getLead(),
          e = !!this.resumingFrom || this !== t,
          i = !0;
        if (
          ((this.isProjectionDirty || this.parent?.isProjectionDirty) && (i = !1),
          e && (this.isSharedProjectionDirty || this.isTransformDirty) && (i = !1),
          this.resolvedRelativeTargetAt === tb.uv.timestamp && (i = !1),
          i)
        )
          return;
        let { layout: n, layoutId: s } = this.options;
        if (
          ((this.isTreeAnimating = !!(
            (this.parent && this.parent.isTreeAnimating) ||
            this.currentAnimation ||
            this.pendingAnimation
          )),
          this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0),
          !this.layout || !(n || s))
        )
          return;
        eV(this.layoutCorrected, this.layout.layoutBox);
        let r = this.treeScale.x,
          o = this.treeScale.y;
        ((0, eD.OU)(this.layoutCorrected, this.treeScale, this.path, e),
          t.layout &&
            !t.target &&
            (1 !== this.treeScale.x || 1 !== this.treeScale.y) &&
            ((t.target = t.layout.layoutBox), (t.targetWithTransforms = (0, td.ge)())));
        let { target: a } = t;
        if (!a) {
          this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
          return;
        }
        (this.projectionDelta && this.prevProjectionDelta
          ? (eC(this.prevProjectionDelta.x, this.projectionDelta.x),
            eC(this.prevProjectionDelta.y, this.projectionDelta.y))
          : this.createProjectionDeltas(),
          tg(this.projectionDelta, this.layoutCorrected, a, this.latestValues),
          (this.treeScale.x === r &&
            this.treeScale.y === o &&
            eG(this.projectionDelta.x, this.prevProjectionDelta.x) &&
            eG(this.projectionDelta.y, this.prevProjectionDelta.y)) ||
            ((this.hasProjected = !0),
            this.scheduleRender(),
            this.notifyListeners("projectionUpdate", a)),
          ev.Q.value && eY.calculatedProjections++);
      }
      hide() {
        this.isVisible = !1;
      }
      show() {
        this.isVisible = !0;
      }
      scheduleRender(t = !0) {
        if ((this.options.visualElement?.scheduleRender(), t)) {
          let t = this.getStack();
          t && t.scheduleRender();
        }
        this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
      }
      createProjectionDeltas() {
        ((this.prevProjectionDelta = (0, td.xU)()),
          (this.projectionDelta = (0, td.xU)()),
          (this.projectionDeltaWithTransform = (0, td.xU)()));
      }
      setAnimationOrigin(t, e = !1) {
        let i,
          n = this.snapshot,
          s = n ? n.latestValues : {},
          r = { ...this.latestValues },
          o = (0, td.xU)();
        ((this.relativeParent && this.relativeParent.options.layoutRoot) ||
          (this.relativeTarget = this.relativeTargetOrigin = void 0),
          (this.attemptToResolveRelativeTarget = !e));
        let a = (0, td.ge)(),
          l = (n ? n.source : void 0) !== (this.layout ? this.layout.source : void 0),
          h = this.getStack(),
          u = !h || h.members.length <= 1,
          d = !!(l && !u && !0 === this.options.crossfade && !this.path.some(il));
        ((this.animationProgress = 0),
          (this.mixTargetDelta = (e) => {
            let n = e / 1e3;
            if (
              (io(o.x, t.x, n),
              io(o.y, t.y, n),
              this.setTargetDelta(o),
              this.relativeTarget &&
                this.relativeTargetOrigin &&
                this.layout &&
                this.relativeParent &&
                this.relativeParent.layout)
            ) {
              var h, c, p, m, f, v;
              (tT(
                a,
                this.layout.layoutBox,
                this.relativeParent.layout.layoutBox,
                this.options.layoutAnchor || void 0,
              ),
                (p = this.relativeTarget),
                (m = this.relativeTargetOrigin),
                (f = a),
                (v = n),
                ia(p.x, m.x, f.x, v),
                ia(p.y, m.y, f.y, v),
                i &&
                  ((h = this.relativeTarget), (c = i), eU(h.x, c.x) && eU(h.y, c.y)) &&
                  (this.isProjectionDirty = !1),
                i || (i = (0, td.ge)()),
                eV(i, this.relativeTarget));
            }
            (l &&
              ((this.animationValues = r),
              (function (t, e, i, n, s, r) {
                s
                  ? ((t.opacity = (0, tf.k)(0, i.opacity ?? 1, eA(n))),
                    (t.opacityExit = (0, tf.k)(e.opacity ?? 1, 0, eE(n))))
                  : r && (t.opacity = (0, tf.k)(e.opacity ?? 1, i.opacity ?? 1, n));
                for (let s = 0; s < eT; s++) {
                  let r = ew[s],
                    o = eP(e, r),
                    a = eP(i, r);
                  (void 0 !== o || void 0 !== a) &&
                    (o || (o = 0),
                    a || (a = 0),
                    0 === o || 0 === a || eS(o) === eS(a)
                      ? ((t[r] = Math.max((0, tf.k)(eb(o), eb(a), n), 0)),
                        (tm.KN.test(a) || tm.KN.test(o)) && (t[r] += "%"))
                      : (t[r] = a));
                }
                (e.rotate || i.rotate) && (t.rotate = (0, tf.k)(e.rotate || 0, i.rotate || 0, n));
              })(r, s, this.latestValues, n, d, u)),
              this.root.scheduleUpdateProjection(),
              this.scheduleRender(),
              (this.animationProgress = n));
          }),
          this.mixTargetDelta(1e3 * !!this.options.layoutRoot));
      }
      startAnimation(t) {
        (this.notifyListeners("animationStart"),
          this.currentAnimation?.stop(),
          this.resumingFrom?.currentAnimation?.stop(),
          this.pendingAnimation &&
            ((0, tb.WG)(this.pendingAnimation), (this.pendingAnimation = void 0)),
          (this.pendingAnimation = tb.Gt.update(() => {
            ((en.hasAnimatedSinceResize = !0),
              ef.q.layout++,
              this.motionValue || (this.motionValue = (0, eg.OQ)(0)),
              this.motionValue.jump(0, !1),
              (this.currentAnimation = (0, eu.z)(this.motionValue, [0, 1e3], {
                ...t,
                velocity: 0,
                isSync: !0,
                onUpdate: (e) => {
                  (this.mixTargetDelta(e), t.onUpdate && t.onUpdate(e));
                },
                onStop: () => {
                  ef.q.layout--;
                },
                onComplete: () => {
                  (ef.q.layout--, t.onComplete && t.onComplete(), this.completeAnimation());
                },
              })),
              this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation),
              (this.pendingAnimation = void 0));
          })));
      }
      completeAnimation() {
        this.resumingFrom &&
          ((this.resumingFrom.currentAnimation = void 0),
          (this.resumingFrom.preserveOpacity = void 0));
        let t = this.getStack();
        (t && t.exitAnimationComplete(),
          (this.resumingFrom = this.currentAnimation = this.animationValues = void 0),
          this.notifyListeners("animationComplete"));
      }
      finishAnimation() {
        (this.currentAnimation &&
          (this.mixTargetDelta && this.mixTargetDelta(1e3), this.currentAnimation.stop()),
          this.completeAnimation());
      }
      applyTransformsToTarget() {
        let t = this.getLead(),
          { targetWithTransforms: e, target: i, layout: n, latestValues: s } = t;
        if (e && i && n) {
          if (
            this !== t &&
            this.layout &&
            n &&
            ip(this.options.animationType, this.layout.layoutBox, n.layoutBox)
          ) {
            i = this.target || (0, td.ge)();
            let e = tv(this.layout.layoutBox.x);
            ((i.x.min = t.target.x.min), (i.x.max = i.x.min + e));
            let n = tv(this.layout.layoutBox.y);
            ((i.y.min = t.target.y.min), (i.y.max = i.y.min + n));
          }
          (eV(e, i),
            (0, eD.Ww)(e, s),
            tg(this.projectionDeltaWithTransform, this.layoutCorrected, e, s));
        }
      }
      registerSharedNode(t, e) {
        (this.sharedNodes.has(t) || this.sharedNodes.set(t, new eq()),
          this.sharedNodes.get(t).add(e));
        let i = e.options.initialPromotionConfig;
        e.promote({
          transition: i ? i.transition : void 0,
          preserveFollowOpacity:
            i && i.shouldPreserveFollowOpacity ? i.shouldPreserveFollowOpacity(e) : void 0,
        });
      }
      isLead() {
        let t = this.getStack();
        return !t || t.lead === this;
      }
      getLead() {
        let { layoutId: t } = this.options;
        return (t && this.getStack()?.lead) || this;
      }
      getPrevLead() {
        let { layoutId: t } = this.options;
        return t ? this.getStack()?.prevLead : void 0;
      }
      getStack() {
        let { layoutId: t } = this.options;
        if (t) return this.root.sharedNodes.get(t);
      }
      promote({ needsReset: t, transition: e, preserveFollowOpacity: i } = {}) {
        let n = this.getStack();
        (n && n.promote(this, i),
          t && ((this.projectionDelta = void 0), (this.needsReset = !0)),
          e && this.setOptions({ transition: e }));
      }
      relegate() {
        let t = this.getStack();
        return !!t && t.relegate(this);
      }
      resetSkewAndRotation() {
        let { visualElement: t } = this.options;
        if (!t) return;
        let e = !1,
          { latestValues: i } = t;
        if (
          ((i.z || i.rotate || i.rotateX || i.rotateY || i.rotateZ || i.skewX || i.skewY) &&
            (e = !0),
          !e)
        )
          return;
        let n = {};
        i.z && eZ("z", t, n, this.animationValues);
        for (let e = 0; e < eQ.length; e++)
          (eZ(`rotate${eQ[e]}`, t, n, this.animationValues),
            eZ(`skew${eQ[e]}`, t, n, this.animationValues));
        for (let e in (t.render(), n))
          (t.setStaticValue(e, n[e]), this.animationValues && (this.animationValues[e] = n[e]));
        t.scheduleRender();
      }
      applyProjectionStyles(t, e) {
        if (!this.instance || this.isSVG) return;
        if (!this.isVisible) {
          t.visibility = "hidden";
          return;
        }
        let i = this.getTransformTemplate();
        if (this.needsReset) {
          ((this.needsReset = !1),
            (t.visibility = ""),
            (t.opacity = ""),
            (t.pointerEvents = C(e?.pointerEvents) || ""),
            (t.transform = i ? i(this.latestValues, "") : "none"));
          return;
        }
        let n = this.getLead();
        if (!this.projectionDelta || !this.layout || !n.target) {
          (this.options.layoutId &&
            ((t.opacity = void 0 !== this.latestValues.opacity ? this.latestValues.opacity : 1),
            (t.pointerEvents = C(e?.pointerEvents) || "")),
            this.hasProjected &&
              !(0, ez.HD)(this.latestValues) &&
              ((t.transform = i ? i({}, "") : "none"), (this.hasProjected = !1)));
          return;
        }
        t.visibility = "";
        let s = n.animationValues || n.latestValues;
        this.applyTransformsToTarget();
        let r = (function (t, e, i) {
          let n = "",
            s = t.x.translate / e.x,
            r = t.y.translate / e.y,
            o = i?.z || 0;
          if (
            ((s || r || o) && (n = `translate3d(${s}px, ${r}px, ${o}px) `),
            (1 !== e.x || 1 !== e.y) && (n += `scale(${1 / e.x}, ${1 / e.y}) `),
            i)
          ) {
            let {
              transformPerspective: t,
              rotate: e,
              rotateX: s,
              rotateY: r,
              skewX: o,
              skewY: a,
            } = i;
            (t && (n = `perspective(${t}px) ${n}`),
              e && (n += `rotate(${e}deg) `),
              s && (n += `rotateX(${s}deg) `),
              r && (n += `rotateY(${r}deg) `),
              o && (n += `skewX(${o}deg) `),
              a && (n += `skewY(${a}deg) `));
          }
          let a = t.x.scale * e.x,
            l = t.y.scale * e.y;
          return ((1 !== a || 1 !== l) && (n += `scale(${a}, ${l})`), n || "none");
        })(this.projectionDeltaWithTransform, this.treeScale, s);
        (i && (r = i(s, r)), (t.transform = r));
        let { x: o, y: a } = this.projectionDelta;
        for (let e in ((t.transformOrigin = `${100 * o.origin}% ${100 * a.origin}% 0`),
        n.animationValues
          ? (t.opacity =
              n === this
                ? (s.opacity ?? this.latestValues.opacity ?? 1)
                : this.preserveOpacity
                  ? this.latestValues.opacity
                  : s.opacityExit)
          : (t.opacity =
              n === this
                ? void 0 !== s.opacity
                  ? s.opacity
                  : ""
                : void 0 !== s.opacityExit
                  ? s.opacityExit
                  : 0),
        em.H)) {
          if (void 0 === s[e]) continue;
          let { correct: i, applyTo: o, isCSSVariable: a } = em.H[e],
            l = "none" === r ? s[e] : i(s[e], n);
          if (o) {
            let e = o.length;
            for (let i = 0; i < e; i++) t[o[i]] = l;
          } else a ? (this.options.visualElement.renderState.vars[e] = l) : (t[e] = l);
        }
        this.options.layoutId &&
          (t.pointerEvents = n === this ? C(e?.pointerEvents) || "" : "none");
      }
      clearSnapshot() {
        this.resumeFrom = this.snapshot = void 0;
      }
      resetTree() {
        (this.root.nodes.forEach((t) => t.currentAnimation?.stop()),
          this.root.nodes.forEach(e5),
          this.root.sharedNodes.clear());
      }
    };
  }
  function e0(t) {
    t.updateLayout();
  }
  function e1(t) {
    let e = t.resumeFrom?.snapshot || t.snapshot;
    if (t.isLead() && t.layout && e && t.hasListeners("didUpdate")) {
      let { layoutBox: i, measuredBox: n } = t.layout,
        { animationType: s } = t.options,
        r = e.source !== t.layout.source;
      if ("size" === s)
        tp((t) => {
          let n = r ? e.measuredBox[t] : e.layoutBox[t],
            s = tv(n);
          ((n.min = i[t].min), (n.max = n.min + s));
        });
      else if ("x" === s || "y" === s) {
        let t = "x" === s ? "y" : "x";
        ek(r ? e.measuredBox[t] : e.layoutBox[t], i[t]);
      } else
        ip(s, e.layoutBox, i) &&
          tp((n) => {
            let s = r ? e.measuredBox[n] : e.layoutBox[n],
              o = tv(i[n]);
            ((s.max = s.min + o),
              t.relativeTarget &&
                !t.currentAnimation &&
                ((t.isProjectionDirty = !0),
                (t.relativeTarget[n].max = t.relativeTarget[n].min + o)));
          });
      let o = (0, td.xU)();
      tg(o, i, e.layoutBox);
      let a = (0, td.xU)();
      r ? tg(a, t.applyTransform(n, !0), e.measuredBox) : tg(a, i, e.layoutBox);
      let l = !eO(o),
        h = !1;
      if (!t.resumeFrom) {
        let n = t.getClosestProjectingParent();
        if (n && !n.resumeFrom) {
          let { snapshot: s, layout: r } = n;
          if (s && r) {
            let o = t.options.layoutAnchor || void 0,
              a = (0, td.ge)();
            tT(a, e.layoutBox, s.layoutBox, o);
            let l = (0, td.ge)();
            (tT(l, i, r.layoutBox, o),
              eN(a, l) || (h = !0),
              n.options.layoutRoot &&
                ((t.relativeTarget = l), (t.relativeTargetOrigin = a), (t.relativeParent = n)));
          }
        }
      }
      t.notifyListeners("didUpdate", {
        layout: i,
        snapshot: e,
        delta: a,
        layoutDelta: o,
        hasLayoutChanged: l,
        hasRelativeLayoutChanged: h,
      });
    } else if (t.isLead()) {
      let { onExitComplete: e } = t.options;
      e && e();
    }
    t.options.transition = void 0;
  }
  function e3(t) {
    (ev.Q.value && eY.nodes++,
      t.parent &&
        (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty),
        t.isSharedProjectionDirty ||
          (t.isSharedProjectionDirty = !!(
            t.isProjectionDirty ||
            t.parent.isProjectionDirty ||
            t.parent.isSharedProjectionDirty
          )),
        t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty)));
  }
  function e2(t) {
    t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
  }
  function e8(t) {
    t.clearSnapshot();
  }
  function e5(t) {
    t.clearMeasurements();
  }
  function e4(t) {
    ((t.isLayoutDirty = !0), t.updateLayout());
  }
  function e9(t) {
    t.isLayoutDirty = !1;
  }
  function e6(t) {
    t.isAnimationBlocked &&
      t.layout &&
      !t.isLayoutDirty &&
      ((t.snapshot = t.layout), (t.isLayoutDirty = !0));
  }
  function e7(t) {
    let { visualElement: e } = t.options;
    (e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"),
      t.resetTransform());
  }
  function it(t) {
    (t.finishAnimation(),
      (t.targetDelta = t.relativeTarget = t.target = void 0),
      (t.isProjectionDirty = !0));
  }
  function ie(t) {
    t.resolveTargetDelta();
  }
  function ii(t) {
    t.calcProjection();
  }
  function is(t) {
    t.resetSkewAndRotation();
  }
  function ir(t) {
    t.removeLeadSnapshot();
  }
  function io(t, e, i) {
    ((t.translate = (0, tf.k)(e.translate, 0, i)),
      (t.scale = (0, tf.k)(e.scale, 1, i)),
      (t.origin = e.origin),
      (t.originPoint = e.originPoint));
  }
  function ia(t, e, i, n) {
    ((t.min = (0, tf.k)(e.min, i.min, n)), (t.max = (0, tf.k)(e.max, i.max, n)));
  }
  function il(t) {
    return t.animationValues && void 0 !== t.animationValues.opacityExit;
  }
  let ih = { duration: 0.45, ease: [0.4, 0, 0.1, 1] },
    iu = (t) =>
      "undefined" != typeof navigator &&
      navigator.userAgent &&
      navigator.userAgent.toLowerCase().includes(t),
    id = iu("applewebkit/") && !iu("chrome/") ? Math.round : tu.l;
  function ic(t) {
    ((t.min = id(t.min)), (t.max = id(t.max)));
  }
  function ip(t, e, i) {
    return "position" === t || ("preserve-aspect" === t && !(0.2 >= Math.abs(e$(e) - e$(i))));
  }
  function im(t) {
    return t !== t.root && t.scroll?.wasRoot;
  }
  let iv = eJ({
      attachResizeListener: (t, e) => tV(t, "resize", e),
      measureScroll: () => ({
        x: document.documentElement.scrollLeft || document.body?.scrollLeft || 0,
        y: document.documentElement.scrollTop || document.body?.scrollTop || 0,
      }),
      checkIsScrollRoot: () => !0,
    }),
    iy = { current: void 0 },
    ig = eJ({
      measureScroll: (t) => ({ x: t.scrollLeft, y: t.scrollTop }),
      defaultParent: () => {
        if (!iy.current) {
          let t = new iv({});
          (t.mount(window), t.setOptions({ layoutScroll: !0 }), (iy.current = t));
        }
        return iy.current;
      },
      resetTransform: (t, e) => {
        t.style.transform = void 0 !== e ? e : "none";
      },
      checkIsScrollRoot: (t) => "fixed" === window.getComputedStyle(t).position,
    });
  function ix(t, e) {
    let i = (0, tD.K)(t),
      n = new AbortController();
    return [i, { passive: !0, ...e, signal: n.signal }, () => n.abort()];
  }
  function iw(t, e, i) {
    let { props: n } = t;
    t.animationState && n.whileHover && t.animationState.setActive("whileHover", "Start" === i);
    let s = n["onHover" + i];
    s && tb.Gt.postRender(() => s(e, t$(e)));
  }
  class iT extends z {
    mount() {
      let { current: t } = this.node;
      t &&
        (this.unmount = (function (t, e, i = {}) {
          let [n, s, r] = ix(t, i);
          return (
            n.forEach((t) => {
              let i,
                n = !1,
                r = !1,
                o = (e) => {
                  (i && (i(e), (i = void 0)), t.removeEventListener("pointerleave", l));
                },
                a = (t) => {
                  ((n = !1),
                    window.removeEventListener("pointerup", a),
                    window.removeEventListener("pointercancel", a),
                    r && ((r = !1), o(t)));
                },
                l = (t) => {
                  if ("touch" !== t.pointerType) {
                    if (n) {
                      r = !0;
                      return;
                    }
                    o(t);
                  }
                };
              (t.addEventListener(
                "pointerenter",
                (n) => {
                  if ("touch" === n.pointerType || tc.x || tc.y) return;
                  r = !1;
                  let o = e(t, n);
                  "function" == typeof o && ((i = o), t.addEventListener("pointerleave", l, s));
                },
                s,
              ),
                t.addEventListener(
                  "pointerdown",
                  () => {
                    ((n = !0),
                      window.addEventListener("pointerup", a, s),
                      window.addEventListener("pointercancel", a, s));
                  },
                  s,
                ));
            }),
            r
          );
        })(t, (t, e) => (iw(this.node, e, "Start"), (t) => iw(this.node, t, "End"))));
    }
    unmount() {}
  }
  class ib extends z {
    constructor() {
      (super(...arguments), (this.isActive = !1));
    }
    onFocus() {
      let t = !1;
      try {
        t = this.node.current.matches(":focus-visible");
      } catch (e) {
        t = !0;
      }
      t &&
        this.node.animationState &&
        (this.node.animationState.setActive("whileFocus", !0), (this.isActive = !0));
    }
    onBlur() {
      this.isActive &&
        this.node.animationState &&
        (this.node.animationState.setActive("whileFocus", !1), (this.isActive = !1));
    }
    mount() {
      this.unmount = (0, tq.F)(
        tV(this.node.current, "focus", () => this.onFocus()),
        tV(this.node.current, "blur", () => this.onBlur()),
      );
    }
    unmount() {}
  }
  var iS = i(81402);
  let iP = (t, e) => !!e && (t === e || iP(t, e.parentElement)),
    iA = new WeakSet();
  function iE(t) {
    return (e) => {
      "Enter" === e.key && t(e);
    };
  }
  function iM(t, e) {
    t.dispatchEvent(new PointerEvent("pointer" + e, { isPrimary: !0, bubbles: !0 }));
  }
  function ik(t) {
    return tN(t) && !(tc.x || tc.y);
  }
  let iV = new WeakSet();
  function iC(t, e, i) {
    let { props: n } = t;
    if (t.current instanceof HTMLButtonElement && t.current.disabled) return;
    t.animationState && n.whileTap && t.animationState.setActive("whileTap", "Start" === i);
    let s = n["onTap" + ("End" === i ? "" : i)];
    s && tb.Gt.postRender(() => s(e, t$(e)));
  }
  class iD extends z {
    mount() {
      let { current: t } = this.node;
      if (!t) return;
      let { globalTapTarget: e, propagate: i } = this.node.props;
      this.unmount = (function (t, e, i = {}) {
        let [n, s, r] = ix(t, i),
          o = (t) => {
            let n = t.currentTarget;
            if (!ik(t) || iV.has(t)) return;
            (iA.add(n), i.stopPropagation && iV.add(t));
            let r = e(n, t),
              o = (t, e) => {
                (window.removeEventListener("pointerup", a),
                  window.removeEventListener("pointercancel", l),
                  iA.has(n) && iA.delete(n),
                  ik(t) && "function" == typeof r && r(t, { success: e }));
              },
              a = (t) => {
                o(t, n === window || n === document || i.useGlobalTarget || iP(n, t.target));
              },
              l = (t) => {
                o(t, !1);
              };
            (window.addEventListener("pointerup", a, s),
              window.addEventListener("pointercancel", l, s));
          };
        return (
          n.forEach((t) => {
            ((i.useGlobalTarget ? window : t).addEventListener("pointerdown", o, s),
            (0, iS.s)(t)) &&
              (t.addEventListener("focus", (t) =>
                ((t, e) => {
                  let i = t.currentTarget;
                  if (!i) return;
                  let n = iE(() => {
                    if (iA.has(i)) return;
                    iM(i, "down");
                    let t = iE(() => {
                      iM(i, "up");
                    });
                    (i.addEventListener("keyup", t, e),
                      i.addEventListener("blur", () => iM(i, "cancel"), e));
                  });
                  (i.addEventListener("keydown", n, e),
                    i.addEventListener("blur", () => i.removeEventListener("keydown", n), e));
                })(t, s),
              ),
              tM.has(t.tagName) ||
                !0 === t.isContentEditable ||
                t.hasAttribute("tabindex") ||
                (t.tabIndex = 0));
          }),
          r
        );
      })(
        t,
        (t, e) => (
          iC(this.node, e, "Start"),
          (t, { success: e }) => iC(this.node, t, e ? "End" : "Cancel")
        ),
        { useGlobalTarget: e, stopPropagation: i?.tap === !1 },
      );
    }
    unmount() {}
  }
  let iR = new WeakMap(),
    iL = new WeakMap(),
    ij = (t) => {
      let e = iR.get(t.target);
      e && e(t);
    },
    iB = (t) => {
      t.forEach(ij);
    },
    iF = { some: 0, all: 1 };
  class iI extends z {
    constructor() {
      (super(...arguments), (this.hasEnteredView = !1), (this.isInView = !1));
    }
    startObserver() {
      this.stopObserver?.();
      let { viewport: t = {} } = this.node.getProps(),
        { root: e, margin: i, amount: n = "some", once: s } = t,
        r = {
          root: e ? e.current : void 0,
          rootMargin: i,
          threshold: "number" == typeof n ? n : iF[n],
        },
        o = (t) => {
          let { isIntersecting: e } = t;
          if (this.isInView === e || ((this.isInView = e), s && !e && this.hasEnteredView)) return;
          (e && (this.hasEnteredView = !0),
            this.node.animationState && this.node.animationState.setActive("whileInView", e));
          let { onViewportEnter: i, onViewportLeave: n } = this.node.getProps(),
            r = e ? i : n;
          r && r(t);
        };
      this.stopObserver = (function (t, e, i) {
        let n = (function ({ root: t, ...e }) {
          let i = t || document;
          iL.has(i) || iL.set(i, {});
          let n = iL.get(i),
            s = JSON.stringify(e);
          return (n[s] || (n[s] = new IntersectionObserver(iB, { root: t, ...e })), n[s]);
        })(e);
        return (
          iR.set(t, i),
          n.observe(t),
          () => {
            (iR.delete(t), n.unobserve(t));
          }
        );
      })(this.node.current, r, o);
    }
    mount() {
      this.startObserver();
    }
    update() {
      if ("undefined" == typeof IntersectionObserver) return;
      let { props: t, prevProps: e } = this.node;
      ["amount", "margin", "root"].some(
        (function ({ viewport: t = {} }, { viewport: e = {} } = {}) {
          return (i) => t[i] !== e[i];
        })(t, e),
      ) && this.startObserver();
    }
    unmount() {
      (this.stopObserver?.(), (this.hasEnteredView = !1), (this.isInView = !1));
    }
  }
  let iO = (function (t, e) {
    if ("undefined" == typeof Proxy) return H;
    let i = new Map(),
      n = (i, n) => H(i, n, t, e);
    return new Proxy((t, e) => n(t, e), {
      get: (s, r) => ("create" === r ? n : (i.has(r) || i.set(r, H(r, void 0, t, e)), i.get(r))),
    });
  })(
    {
      animation: { Feature: ta },
      exit: { Feature: th },
      inView: { Feature: iI },
      tap: { Feature: iD },
      focus: { Feature: ib },
      hover: { Feature: iT },
      pan: { Feature: ei },
      drag: { Feature: et, ProjectionNode: ig, MeasureLayout: el },
      layout: { ProjectionNode: ig, MeasureLayout: el },
    },
    (t, e) => ((e.isSVG ?? h(t)) ? new r.l(e) : new o.M(e, { allowProjection: t !== a.Fragment })),
  );
}
